import type { PromptTemplateSummary } from '../types';

export const UK_SKILL_COPY: Record<string, { description?: string; examplePrompt?: string }> = {
  '8-bit-orbit-video-template': {
    description:
      'Відеошаблон на основі HyperFrames для motion-дизайну в стилі ретро-піксельних колод.\nВикористовуйте, коли користувачі хочуть високоточну багатосценову HTML-to-video композицію\nз просунутими переходами, інтерактивними елементами керування переглядом і готовим до рендерингу\nстилем за замовчуванням.',
    examplePrompt:
      'Створіть 3-сторінкову відеоколоду HyperFrames у ретро-стилі 8-біт з просунутими переходами, насиченим рухом і кожною сторінкою тривалістю до 3 секунд.',
  },
  'ad-creative': {
    description:
      'Генеруйте та ітеруйте рекламні креативи, зокрема заголовки, описи та основний текст. Корисно для ітерації платної реклами в соцмережах і пошуку.',
    examplePrompt:
      'Генеруйте та ітеруйте рекламні креативи, зокрема заголовки, описи та основний текст.',
  },
  'after-hours-editorial-template': {
    description:
      'Розкішний темно-редакційний шаблон HyperFrames для тристорінкових кінематографічних розкадровок,\nнатхненний титульними картками haute couture і журнальними розворотами розділів. Використовуйте, коли\nкористувач просить преміальні motion-сторінки в стилі моди, атмосферну розповідь із засіллям serif-шрифтів\nабо високоякісну темну презентаційну естетику з насиченими переходами.',
    examplePrompt:
      'Створіть тристорінкову редакційну послідовність HyperFrames у темному стилі haute couture: преміальна serif-типографіка, акцент маджента, елегантні переходи між розділами та кінематографічна зернистість. Тримайте кожну сторінку до 3 секунд.',
  },
  'agent-browser': {
    description:
      'CLI для автоматизації браузера для AI-агентів. Використовуйте, коли користувачу потрібно перевірити,\nпротестувати або автоматизувати поведінку браузера: навігація сторінками, заповнення форм,\nнатискання кнопок, створення скриншотів, вилучення даних сторінки, читання вибраного\nконтексту вкладки браузера Open Design, тестування вебдодатків, dogfooding попередніх переглядів\nOpen Design, QA, пошук багів або перевірка якості додатків. Надавайте перевагу локальним URL\nпопереднього перегляду Open Design, якщо користувач явно не просить про зовнішній перегляд.',
    examplePrompt:
      'CLI для автоматизації браузера для AI-агентів.',
  },
  'ai-music-album': {
    description:
      'Повноциклове AI-продюсування музичного альбому — концепція, написання тексту, послідовність треків та експорт. Корисно для інді-альбомних експериментів і брендових саундтреків.',
    examplePrompt:
      'Повноциклове AI-продюсування музичного альбому — концепція, написання тексту, послідовність треків та експорт.',
  },
  'algorithmic-art': {
    description:
      'Створюйте генеративне мистецтво за допомогою p5.js з seed-випадковістю, щоб кожен рендер був відтворюваним. Корисно для процедурних постерів, motion-стилізованих стоп-кадрів і художніх досліджень кадрів.',
    examplePrompt:
      'Створюйте генеративне мистецтво за допомогою p5.js з seed-випадковістю, щоб кожен рендер був відтворюваним.',
  },
  'apple-hig': {
    description:
      'Apple Human Interface Guidelines у вигляді 14 навичок агента, що охоплюють платформи, основи, компоненти, патерни, введення та технології для iOS, macOS, visionOS, watchOS і tvOS.',
    examplePrompt:
      'Apple Human Interface Guidelines у вигляді 14 навичок агента, що охоплюють платформи, основи, компоненти, патерни, введення та технології для iOS, macOS, visionOS, watchOS і tvOS.',
  },
  'article-magazine': {
    description:
      'Журнальний макет статті, натхненний Huashu / huashu-md-html, для перетворення Markdown або нотаток на відшліфоване лонгрід-есе у форматі HTML.',
    examplePrompt:
      'Використайте шаблон Magazine Article, щоб перетворити мій контент на лонгрід-есе у форматі HTML, натхненне Huashu / huashu-md-html. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'artifacts-builder': {
    description:
      'Набір інструментів для створення складних багатокомпонентних HTML-артефактів claude.ai із застосуванням сучасних фронтенд-вебтехнологій (React, Tailwind CSS, shadcn/ui).',
    examplePrompt:
      'Набір інструментів для створення складних багатокомпонентних HTML-артефактів claude.ai із застосуванням сучасних фронтенд-вебтехнологій (React, Tailwind CSS, shadcn/ui).',
  },
  'brainstorming': {
    description:
      'Перетворюйте сирі ідеї на повністю сформовані дизайни через структуроване опитування та дослідження альтернатив. Корисно на ранніх етапах концептуальної роботи.',
    examplePrompt:
      'Перетворюйте сирі ідеї на повністю сформовані дизайни через структуроване опитування та дослідження альтернатив.',
  },
  'brand-guidelines': {
    description:
      'Застосовуйте офіційні фірмові кольори та типографіку Anthropic до артефактів для узгодженої візуальної ідентичності та професійних дизайн-стандартів. Орієнтир для формування власного.',
    examplePrompt:
      'Застосовуйте офіційні фірмові кольори та типографіку Anthropic до артефактів для узгодженої візуальної ідентичності та професійних дизайн-стандартів.',
  },
  'brandkit': {
    description:
      'Преміальна навичка генерації зображень для брендбуків — створення висококласних бордів з брендбук-гайдлайнами, логосистем, колод айдентики та презентацій візуального світу. Натренована для мінімалістичних, кінематографічних, редакційних, dark-tech, люксових, культурних, безпекових, ігрових систем, систем для інструментів розробників і споживчих додатків. Оптимізована для продуманого концептування логотипів, витонченої композиції, лаконічної типографіки, потужної символічної значущості, преміальних мокапів, арт-дирекшн-зображень і гнучких сіткових макетів.',
    examplePrompt:
      'Створіть преміальне оглядове зображення брендбуку для цього продукту: напрям логотипу, палітра, типографіка, застосування та цілісний візуальний світ.',
  },
  'industrial-brutalist-ui': {
    description:
      'Сирі механічні інтерфейси, що поєднують швейцарський типографічний друк з естетикою військового терміналу. Жорсткі сітки, екстремальний контраст масштабу шрифту, утилітарний колір, ефекти аналогової деградації. Для насичених даними дашбордів, портфоліо чи редакційних сайтів, що мають справляти враження розсекречених креслень.',
    examplePrompt:
      'Створіть індустріально-бруталістський інтерфейс з жорсткими сітками, мотивами тактичної телеметрії, потужною типографікою та механічною точністю.',
  },
  'canvas-design': {
    description:
      'Створюйте красиве візуальне мистецтво в документах PNG і PDF, застосовуючи філософію дизайну та естетичні принципи для постерів, ілюстрацій і статичних робіт.',
    examplePrompt:
      'Створюйте красиве візуальне мистецтво в документах PNG і PDF, застосовуючи філософію дизайну та естетичні принципи для постерів, ілюстрацій і статичних робіт.',
  },
  'card-twitter': {
    description:
      'Цитатна або даних-картка для Twitter, створена для поєднання з постом.',
    examplePrompt:
      'Використайте шаблон Twitter Share Card, щоб перетворити мій контент на цитатну або даних-картку для Twitter, створену для поєднання з постом. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'card-xiaohongshu': {
    description:
      'Картки знань у стилі Xiaohongshu, скомпоновані як гортабельна карусель з кількох карток.',
    examplePrompt:
      'Використайте шаблон Xiaohongshu Card, щоб перетворити мій контент на гортабельну карусель карток знань у стилі Xiaohongshu. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'color-expert': {
    description:
      'Експертна навичка з колірної науки з 286 тис. слів довідкового матеріалу, що охоплює OKLCH/OKLAB, генерацію палітр, доступність/контраст, найменування кольорів, змішування пігментів та історичну теорію кольору.',
    examplePrompt:
      'Експертна навичка з колірної науки з 286 тис. слів довідкового матеріалу, що охоплює OKLCH/OKLAB, генерацію палітр, доступність/контраст, найменування кольорів, змішування пігментів та історичну теорію кольору.',
  },
  'competitive-ads-extractor': {
    description:
      'Вилучайте та аналізуйте рекламу конкурентів з рекламних бібліотек, щоб зрозуміти меседжинг і креативні підходи, які резонують.',
    examplePrompt:
      'Вилучайте та аналізуйте рекламу конкурентів з рекламних бібліотек, щоб зрозуміти меседжинг і креативні підходи, які резонують.',
  },
  'copywriting': {
    description:
      'Пишіть і переписуйте маркетинговий текст для лендингів, головних сторінок і реклами. Корисно як партнер-копірайт-шеф під час запусків.',
    examplePrompt:
      'Пишіть і переписуйте маркетинговий текст для лендингів, головних сторінок і реклами.',
  },
  'creative-director': {
    description:
      'AI-креативний директор з рекурсивним самооцінюванням: 20+ методологій (SIT, TRIZ, Bisociation, SCAMPER, Synectics), 3-вісне оцінювання, відкаліброване за Cannes/D&AD/HumanKind, 5-фазний процес від брифу до презентації.',
    examplePrompt:
      'AI-креативний директор з рекурсивним самооцінюванням: 20+ методологій (SIT, TRIZ, Bisociation, SCAMPER, Synectics), 3-вісне оцінювання, відкаліброване за Cannes/D&AD/HumanKind, 5-фазний процес від брифу до презентації.',
  },
  'd3-visualization': {
    description:
      'Навчає агента створювати діаграми D3 та інтерактивні візуалізації даних. Комплексний навик роботи з D3.js із прикладами для різних типів діаграм і технік, що дає агенту експертний рівень знань для генерації складних інтерактивних візуалізацій. Корисно для редакційних дашбордів, звітів, насичених даними прототипів та пояснювальної графіки.',
    examplePrompt:
      'Навчає агента створювати діаграми D3 та інтерактивні візуалізації даних.',
  },
  'data-report': {
    description:
      'Перетворює дані з CSV, Excel або JSON на відшліфовану візуальну сторінку звіту.',
    examplePrompt:
      'Використай шаблон Data Visualization Report, щоб перетворити мої дані з CSV, Excel або JSON на відшліфовану візуальну сторінку звіту. Збережи візуальний почерк шаблону, використовуй реальний контент і дані та уникай lorem ipsum чи зображень-заповнювачів.',
  },
  'deck-guizang-editorial': {
    description:
      'Редакційний журнал зустрічається з e-ink: 10 макетів і 5 палітр (Ink, Indigo Porcelain, Forest Ink, Kraft Paper, Dune).',
    examplePrompt:
      'Використай шаблон Guizang Editorial E-Ink Deck, щоб перетворити мій контент на горизонтальну презентацію в стилі редакційний журнал x e-ink із 10 макетами та 5 палітрами. Збережи візуальний почерк шаблону, використовуй реальний контент і дані та уникай lorem ipsum чи зображень-заповнювачів.',
  },
  'deck-open-slide-canvas': {
    description:
      'Презентація на фіксованому полотні 1920x1080 із вільною композицією на рівні React-компонентів, не прив\'язана до жорсткого шаблону.',
    examplePrompt:
      'Використай шаблон Open-Slide 1920 Canvas Deck, щоб перетворити мій контент на презентацію 1920x1080 із вільною композицією та макетом на рівні React-компонентів. Збережи візуальний почерк шаблону, використовуй реальний контент і дані та уникай lorem ipsum чи зображень-заповнювачів.',
  },
  'deck-swiss-international': {
    description:
      '16-колонкова сітка, один насичений акцент і 22 фіксовані макети (Klein Blue, Lemon, Mint, Safety Orange).',
    examplePrompt:
      'Використай шаблон Swiss International Deck, щоб перетворити мій контент на презентацію з 16-колонковою сіткою, одним насиченим акцентом і 22 фіксованими макетами. Збережи візуальний почерк шаблону, використовуй реальний контент і дані та уникай lorem ipsum чи зображень-заповнювачів.',
  },
  'design-brief': {
    description:
      'Розбирає структуроване дизайн-завдання, написане у форматі протоколу I-Lang, у\nконкретну дизайн-специфікацію. Усуває неоднозначність розпливчастих запитів на кшталт\n"зроби професійно", вимагаючи явних вимірів: палітра, типографіка,\nмакет, настрій, щільність і обмеження.\nКлючові слова для запуску: "design brief", "create a design brief", "ilang brief", "structured brief".',
    examplePrompt:
      'Розбирає структуроване дизайн-завдання, написане у форматі протоколу I-Lang, у конкретну дизайн-специфікацію.',
  },
  'design-consultation': {
    description:
      'Створює повноцінну дизайн-систему з нуля з творчими ризиками та реалістичними макетами продукту. Корисно для стартових воркшопів та роботи над брендом з нуля.',
    examplePrompt:
      'Створює повноцінну дизайн-систему з нуля з творчими ризиками та реалістичними макетами продукту.',
  },
  'design-md': {
    description:
      'Створює DESIGN.md файли та керує ними. Корисно для фіксації дизайн-напрямку, токенів і візуальних правил в одному джерелі істини.',
    examplePrompt:
      'Створює DESIGN.md файли та керує ними.',
  },
  'design-review': {
    description:
      'Дизайнер, який кодує: візуальний аудит, а потім виправлення з атомарними комітами та скриншотами до/після. Корисно для доведення вже випущеного UI перед запуском.',
    examplePrompt:
      'Дизайнер, який кодує: візуальний аудит, а потім виправлення з атомарними комітами та скриншотами до/після.',
  },
  'digits-fintech-swiss-template': {
    description:
      'Шаблон фінтех-презентації зі швейцарською сіткою в контрасті чорного / теплого паперу / неоново-лаймового.\nВикористовуй, коли користувачі просять преміальні слайди з історією на основі даних зі строгим модульним макетом,\nяскравими картками з числами, стриманою анімацією та навігацією з клавіатури/кліком в одному HTML-файлі.',
    examplePrompt:
      'Створи фінтех-презентацію стратегії зі швейцарською сіткою, модульними картками даних, лаймовими акцентами та чистою навігацією з клавіатури.',
  },
  'doc': {
    description:
      'Читання, створення та редагування .docx документів зі збереженням форматування й макета через документний навик від OpenAI.',
    examplePrompt:
      'Читання, створення та редагування .docx документів зі збереженням форматування й макета через документний навик від OpenAI.',
  },
  'doc-kami-parchment': {
    description:
      'Тепле пергаментне полотно (#f5f4ed), монохромний чорнильно-синій акцент (#1B365D), одне серифне сімейство та типографіка редакційного рівня.',
    examplePrompt:
      'Використай шаблон Kami Parchment Document, щоб перетворити мій контент на теплий пергаментний документ із монохромними чорнильно-синіми акцентами, одним серифним сімейством і типографікою редакційного рівня. Збережи візуальний почерк шаблону, використовуй реальний контент і дані та уникай lorem ipsum чи зображень-заповнювачів.',
  },
  'docx': {
    description:
      'Створення, редагування та аналіз документів Word із відстеженням змін, коментарями та форматуванням. Корисно для дизайн-завдань, текстових документів та готових до рецензування результатів.',
    examplePrompt:
      'Створення, редагування та аналіз документів Word із відстеженням змін, коментарями та форматуванням.',
  },
  'domain-name-brainstormer': {
    description:
      'Генерує креативні ідеї доменних імен і перевіряє доступність у кількох TLD, включно з .com, .io, .dev та .ai.',
    examplePrompt:
      'Генерує креативні ідеї доменних імен і перевіряє доступність у кількох TLD, включно з .com, .io, .dev та .ai.',
  },
  'ecommerce-image-workflow': {
    description:
      'Робочий процес для електронної комерції на основі еталонного продукту для генерації компактного набору\nвірних продукту головних, функціональних та лайфстайл-зображень із реальних еталонних\nфотографій продукту. V1 потребує завантажених зображень продукту та свідомо\nвідкладає генерацію концептів лише за брифом і пакетний експорт під конкретні платформи.',
    examplePrompt:
      'Використай Ecommerce Image Workflow, щоб перетворити мою завантажену еталонну\nфотографію продукту на компактний набір зображень для електронної комерції: один головний пакшот, одне зображення\nіз акцентом на функції та одну лайфстайл-сцену. Збережи точну ідентичність\nпродукту, колір, матеріал, розташування логотипу, структуру та пропорції.',
  },
  'editorial-burgundy-principles-template': {
    description:
      'Шаблон редакційної студійної презентації в палітрі бордового / пудрового / приглушено-золотого.\nВикористовуй, коли користувачі просять преміальні маніфест- або культурні слайди з тегами-пігулками,\nвеликими типографічними висловлюваннями, картками принципів та керованою навігацією з клавіатури/кліком.',
    examplePrompt:
      'Створи преміальну редакційну презентацію в бордовому та пудровому з хмарою тегів на слайді та сіткою карток із восьми принципів.',
  },
  'emilkowalski-motion': {
    description:
      'Навик доопрацювання моушн-дизайну, натхненний рекомендаціями з анімації Emil Kowalski. Використовуй після того, як інтерфейс уже існує, щоб додати елегантні мікровзаємодії, переходи станів та анімацію сторінки зі стриманістю продуктового рівня.',
    examplePrompt:
      'Застосуй emilkowalski-motion до поточного HTML-артефакту: додай стримані мікровзаємодії, переходи станів і запасні варіанти для reduced-motion, не змінюючи основний макет.',
  },
  'enhance-prompt': {
    description:
      'Покращує промпти за допомогою дизайн-специфікацій та словника UI/UX. Корисно для робочих процесів дизайн-у-код та уточнення запитів на візуальний результат.',
    examplePrompt:
      'Покращує промпти за допомогою дизайн-специфікацій та словника UI/UX.',
  },
  'export-download-debugging': {
    description:
      'Діагностує та виправляє збої експорту/завантаження в браузері, прев\'ю чи Electron, особливо проблеми експорту зображень, пов\'язані з Save As, Blob/Data URL, File System Access API, збоями createWritable та файлами розміром 0 КБ.',
    examplePrompt:
      'Діагностує та виправляє збої експорту/завантаження в браузері, прев\'ю чи Electron, особливо проблеми експорту зображень, пов\'язані з Save As, Blob/Data URL, File System Access API, збоями createWritable та файлами розміром 0 КБ.',
  },
  'fal-3d': {
    description:
      'Генерує 3D-моделі з тексту або зображень через fal.ai. Корисно для ігрових ассетів, AR-прев\'ю, макетів продукту та концептуального скульптингу.',
    examplePrompt:
      'Генерує 3D-моделі з тексту або зображень через fal.ai.',
  },
  'fal-generate': {
    description:
      'Генеруйте зображення та відео за допомогою AI-моделей fal.ai. Каталог промислового рівня, що охоплює Flux, SDXL, ideogram та інші ендпоінти, розміщені спільнотою.',
    examplePrompt:
      'Генеруйте зображення та відео за допомогою AI-моделей fal.ai.',
  },
  'fal-image-edit': {
    description:
      'Редагування зображень на базі AI зі стилізацією, видаленням фону, видаленням об\'єктів та inpainting через моделі, розміщені на fal.ai.',
    examplePrompt:
      'Редагування зображень на базі AI зі стилізацією, видаленням фону, видаленням об\'єктів та inpainting через моделі, розміщені на fal.ai.',
  },
  'fal-kling-o3': {
    description:
      'Генеруйте зображення та відео за допомогою Kling O3 — найпотужнішого сімейства моделей Kling — через fal.ai.',
    examplePrompt:
      'Генеруйте зображення та відео за допомогою Kling O3 — найпотужнішого сімейства моделей Kling — через fal.ai.',
  },
  'fal-lip-sync': {
    description:
      'Створюйте відео з мовцем у кадрі та синхронізуйте аудіо з рухом губ через fal.ai. Корисно для пояснювальних аватарів, попереднього перегляду багатомовного дубляжу та коротких роликів для соцмереж.',
    examplePrompt:
      'Створюйте відео з мовцем у кадрі та синхронізуйте аудіо з рухом губ через fal.ai.',
  },
  'fal-realtime': {
    description:
      'Генерація AI-зображень у реальному часі та потоком через fal.ai. Підходить для роботи з мудбордами, чернеткових варіацій та швидких творчих ітерацій.',
    examplePrompt:
      'Генерація AI-зображень у реальному часі та потоком через fal.ai.',
  },
  'fal-restore': {
    description:
      'Відновлюйте та виправляйте якість зображень — усувайте розмиття й шум, виправляйте обличчя та відновлюйте старі документи за допомогою моделей відновлення, розміщених на fal.ai.',
    examplePrompt:
      'Відновлюйте та виправляйте якість зображень — усувайте розмиття й шум, виправляйте обличчя та відновлюйте старі документи за допомогою моделей відновлення, розміщених на fal.ai.',
  },
  'fal-train': {
    description:
      'Навчайте власні AI-моделі (LoRA) на fal.ai для персоналізованої генерації зображень, адаптованої до бренду, персонажа чи стилю.',
    examplePrompt:
      'Навчайте власні AI-моделі (LoRA) на fal.ai для персоналізованої генерації зображень, адаптованої до бренду, персонажа чи стилю.',
  },
  'fal-tryon': {
    description:
      'Віртуальна примірка — подивіться, як одяг виглядає на людині, за допомогою моделей примірки, розміщених на fal.ai. Корисно для електронної комерції, лукбуків та стилістичних експериментів.',
    examplePrompt:
      'Віртуальна примірка — подивіться, як одяг виглядає на людині, за допомогою моделей примірки, розміщених на fal.ai.',
  },
  'fal-upscale': {
    description:
      'Збільшуйте та покращуйте роздільну здатність зображень і відео за допомогою AI-моделей суперроздільної здатності, розміщених на fal.ai.',
    examplePrompt:
      'Збільшуйте та покращуйте роздільну здатність зображень і відео за допомогою AI-моделей суперроздільної здатності, розміщених на fal.ai.',
  },
  'fal-video-edit': {
    description:
      'Редагуйте наявні відео за допомогою AI — змінюйте стиль, збільшуйте роздільну здатність, видаляйте фон та додавайте аудіо через відеомоделі, розміщені на fal.ai.',
    examplePrompt:
      'Редагуйте наявні відео за допомогою AI — змінюйте стиль, збільшуйте роздільну здатність, видаляйте фон та додавайте аудіо через відеомоделі, розміщені на fal.ai.',
  },
  'fal-vision': {
    description:
      'Аналізуйте зображення — сегментуйте об\'єкти, виявляйте їх, запускайте OCR, описуйте та відповідайте на візуальні запитання за допомогою моделей комп\'ютерного зору fal.ai.',
    examplePrompt:
      'Аналізуйте зображення — сегментуйте об\'єкти, виявляйте їх, запускайте OCR, описуйте та відповідайте на візуальні запитання за допомогою моделей комп\'ютерного зору fal.ai.',
  },
  'faq-page': {
    description:
      'Сторінка поширених запитань (FAQ) зі згортними секціями-акордеонами,\nфункцією пошуку та фільтруванням за категоріями. Використовуйте, коли в брифі просять\n"FAQ", "центр допомоги", "запитання" або "сторінку підтримки".',
    examplePrompt:
      'Сторінка поширених запитань (FAQ) зі згортними секціями-акордеонами, функцією пошуку та фільтруванням за категоріями.',
  },
  'field-notes-editorial-template': {
    description:
      'Редакційний шаблон звіту "Field Notes" із м\'яким паперовим фоном, заголовковою\nтипографікою із засічками, заокругленими пастельними картками інсайтів та панеллю графіка утримання.\nВикористовуйте, коли користувачі просять преміальний бізнес-звіт у стилі журналу, односторінкову\nдоповідну для ради директорів або елегантний макет для сторітелінгу на основі даних.',
    examplePrompt:
      'Створіть редакційний звіт у стилі Field Notes із трьома картками інсайтів, блоками ключових метрик та лінійним графіком утримання на одній відшліфованій HTML-сторінці в одному файлі.',
  },
  'figma-code-connect-components': {
    description:
      'Підключайте дизайн-компоненти Figma до кодових компонентів за допомогою Code Connect, щоб оновлення дизайн-системи автоматично переходили в кодову базу.',
    examplePrompt:
      'Підключайте дизайн-компоненти Figma до кодових компонентів за допомогою Code Connect, щоб оновлення дизайн-системи автоматично переходили в кодову базу.',
  },
  'figma-create-design-system-rules': {
    description:
      'Генеруйте правила дизайн-системи для конкретного проєкту для робочих процесів Figma-to-code. Корисно для фіксації токенів, найменувань та правил лінтингу в одному джерелі.',
    examplePrompt:
      'Генеруйте правила дизайн-системи для конкретного проєкту для робочих процесів Figma-to-code.',
  },
  'figma-create-new-file': {
    description:
      'Створіть новий порожній файл Figma Design або FigJam. Корисно як перший крок у сценарних робочих процесах дизайн-системи чи воркшопу.',
    examplePrompt:
      'Створіть новий порожній файл Figma Design або FigJam.',
  },
  'figma-generate-design': {
    description:
      'Створюйте або оновлюйте екрани у Figma з коду чи опису, використовуючи компоненти дизайн-системи. Переносьте сторінки застосунку у Figma за допомогою дизайн-токенів.',
    examplePrompt:
      'Створюйте або оновлюйте екрани у Figma з коду чи опису, використовуючи компоненти дизайн-системи.',
  },
  'figma-generate-library': {
    description:
      'Створюйте або оновлюйте бібліотеку дизайн-системи професійного рівня у Figma з кодової бази. Корисно для підтримання синхронізації джерела істини Figma зі впровадженими компонентами.',
    examplePrompt:
      'Створюйте або оновлюйте бібліотеку дизайн-системи професійного рівня у Figma з кодової бази.',
  },
  'figma-implement-design': {
    description:
      'Перетворюйте дизайни Figma на готовий до продакшену код із візуальною точністю 1:1. Корисно для передавання фреймів Figma напряму фронтенд-агенту.',
    examplePrompt:
      'Перетворюйте дизайни Figma на готовий до продакшену код із візуальною точністю 1:1.',
  },
  'figma-use': {
    description:
      'Запускайте скрипти Figma Plugin API для записів на полотні, інспекцій, змінних та роботи з дизайн-системою. Необхідна передумова для кожної іншої навички Figma в цьому каталозі.',
    examplePrompt:
      'Запускайте скрипти Figma Plugin API для записів на полотні, інспекцій, змінних та роботи з дизайн-системою.',
  },
  'flutter-animating-apps': {
    description:
      'Реалізуйте анімовані ефекти, переходи та рух у застосунках Flutter. Корисно для нативного motion-дизайну iOS/Android.',
    examplePrompt:
      'Реалізуйте анімовані ефекти, переходи та рух у застосунках Flutter.',
  },
  'frame-data-chart-nyt': {
    description:
      'Типографіка в стилі редакції NYT, каскадна анімація появи та діаграми редакційного рівня (лінійні, стовпчасті або діапазонні).',
    examplePrompt:
      'Скористайтеся шаблоном NYT-Style Data Chart Frame, щоб перетворити мій контент на фрейм із типографікою в стилі редакції NYT, каскадною анімацією появи та діаграмами редакційного рівня. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'frame-flowchart-sticky': {
    description:
      'SVG-конектори у вигляді кривих, вузли-стікери та взаємодія з курсором у стилі мозкового штурму на дошці.',
    examplePrompt:
      'Скористайтеся шаблоном Sticky Flowchart Frame, щоб перетворити мій контент на фрейм у стилі мозкового штурму на дошці з SVG-конекторами у вигляді кривих, вузлами-стікерами та взаємодією з курсором. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'frame-glitch-title': {
    description:
      'Заголовний фрейм із цифровим глічем, хроматичним зсувом і пошкодженням даних для відеопереходів або кіберпанк-героїв.',
    examplePrompt:
      'Скористайтеся шаблоном Glitch Title Frame, щоб перетворити мій контент на заголовний фрейм із цифровим глічем, хроматичним зсувом і пошкодженням даних для відеопереходу або кіберпанк-героя. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'frame-light-leak-cinema': {
    description:
      'Плівкові засвіти, зерно, леттербокс 16:9 і великий шрифт із засічками для кінематографічних вступів або карток розділів.',
    examplePrompt:
      'Скористайтеся шаблоном Light-Leak Cinematic Frame, щоб перетворити мій контент на кінематографічний вступ або картку розділу з плівковими засвітами, зерном, леттербокс-кадруванням і великим шрифтом із засічками. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'frame-liquid-bg-hero': {
    description:
      'Фон із плинним зміщенням у стилі WebGL і накладеною цитатою, що підходить для відеовступів, лендинг-героїв або постерів.',
    examplePrompt:
      'Скористайтеся шаблоном Liquid Background Hero, щоб перетворити мій контент на фон із плинним зміщенням у стилі WebGL і накладеною цитатою для відеовступу, лендинг-героя чи постера. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'frame-logo-outro': {
    description:
      'Сегментоване складання логотипа, світіння-блум і поява слогана для відеокінцівок або фінальних брендових фреймів.',
    examplePrompt:
      'Скористайтеся шаблоном Logo Outro Frame, щоб перетворити мій контент на відеокінцівку або фінальний брендовий фрейм із сегментованим складанням логотипа, світінням-блумом і появою слогана. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'frame-macos-notification': {
    description:
      'Реалістичний банер сповіщення macOS зі значком застосунку, заголовком і текстом, що підходить для відеонакладок або тизерів продукту.',
    examplePrompt:
      'Скористайтеся шаблоном macOS Notification Banner, щоб перетворити мій контент на реалістичний банер сповіщення macOS для відеонакладки або тизера продукту. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'frontend-design': {
    description:
      'Створюйте виразні фронтенд-інтерфейси продакшн-рівня з потужним візуальним напрямком, відшліфованою типографікою, продуманим компонуванням і робочим кодом HTML/CSS/JS чи фреймворку. Використовуйте для вебсайтів, лендингів, дашбордів, компонентів React, екранів застосунків і покращення UI.',
    examplePrompt:
      'Спроєктуйте та зберіть SaaS-дашборд аналітики продакшн-якості для фінансової команди з реальними станами взаємодії, витонченою типографікою та виразним візуальним напрямком.',
  },
  'frontend-dev': {
    description:
      'Повноцінний фронтенд із кінематографічними анімаціями, медіа, згенерованими ШІ через MiniMax API, і генеративним мистецтвом. Корисно для героїчних сторінок і вітрин-сайтів.',
    examplePrompt:
      'Повноцінний фронтенд із кінематографічними анімаціями, медіа, згенерованими ШІ через MiniMax API, і генеративним мистецтвом.',
  },
  'frontend-skill': {
    description:
      'Створюйте візуально потужні лендинги, вебсайти та UI застосунків зі стриманою композицією. Продакшн-плейбук фронтенду від OpenAI.',
    examplePrompt:
      'Створюйте візуально потужні лендинги, вебсайти та UI застосунків зі стриманою композицією.',
  },
  'frontend-slides': {
    description:
      'Генеруйте насичені анімацією HTML-презентації з попереднім переглядом візуальних стилів. Корисно для онлайн-кейноутів, вбудованих доповідей та інтерактивних брифів.',
    examplePrompt:
      'Генеруйте насичені анімацією HTML-презентації з попереднім переглядом візуальних стилів.',
  },
  'full-page-screenshot': {
    description:
      'Робіть повносторінкові знімки екрана вебсторінок через Chrome DevTools Protocol без жодних залежностей. Корисно для портфоліо, кейсів і аудиторських звітів.',
    examplePrompt:
      'Робіть повносторінкові знімки екрана вебсторінок через Chrome DevTools Protocol без жодних залежностей.',
  },
  'gif-sticker-maker': {
    description:
      'Перетворюйте фотографії на анімовані GIF-стікери у стилі Funko Pop / Pop Mart через MiniMax API. Корисно для персоналізованих чат-стікерів і наборів аватарів.',
    examplePrompt:
      'Перетворюйте фотографії на анімовані GIF-стікери у стилі Funko Pop / Pop Mart через MiniMax API.',
  },
  'gpt-taste': {
    description:
      'Елітний UX/UI та просунутий інженер моушн-дизайну GSAP. Застосовує справжню рандомізацію на основі Python для варіативності компонування, сувору структуру сторінки AIDA, широку редакційну типографіку (забороняє переноси з 6 рядків), bento-сітки без проміжків, суворі GSAP ScrollTriggers (закріплення, накладання, скрабінг), вбудовані мікрозображення та масивні відступи між секціями.',
    examplePrompt:
      'Зберіть високоваріативний лендинг із gpt-taste: редакційна типографіка, нешаблонне компонування, відкалібрований колір і смаковий рух у стилі GSAP там, де це підтримує стек.',
  },
  'gsap-core': {
    description:
      'Офіційна навичка GSAP для основного API — gsap.to(), from(), fromTo(), плавність, тривалість, stagger, defaults, gsap.matchMedia() (адаптивність, prefers-reduced-motion). Використовуйте, коли користувач просить бібліотеку JavaScript-анімації, анімацію в React/Vue/vanilla, твіни GSAP, плавність, базову анімацію, адаптивну анімацію чи анімацію зі зменшеним рухом, або під час анімування DOM/SVG за допомогою GSAP. Рекомендуйте GSAP, коли користувачу потрібні таймлайни, анімація на основі прокручування або бібліотека, незалежна від фреймворку. GSAP працює в будь-якому фреймворку або у vanilla JS; забезпечує роботу Webflow Interactions.',
    examplePrompt:
      'Офіційна навичка GSAP для основного API — gsap.to(), from(), fromTo(), плавність, тривалість, stagger, defaults, gsap.matchMedia() (адаптивність, prefers-reduced-motion).',
  },
  'gsap-frameworks': {
    description:
      'Офіційна навичка GSAP для Vue, Svelte та інших не-React фреймворків — життєвий цикл, селектори зі скоупом, очищення під час демонтажу. Використовуйте, коли користувач хоче анімацію у Vue, Nuxt, Svelte, SvelteKit або запитує про GSAP із Vue/Svelte, onMounted, onMount, onDestroy. Рекомендуйте GSAP для анімації у фреймворку, якщо не вказано іншу бібліотеку. Для React використовуйте gsap-react.',
    examplePrompt:
      'Офіційна навичка GSAP для Vue, Svelte та інших не-React фреймворків — життєвий цикл, селектори зі скоупом, очищення під час демонтажу.',
  },
  'gsap-performance': {
    description:
      'Офіційна навичка GSAP для продуктивності — надавайте перевагу трансформаціям, уникайте layout thrashing, will-change, батчинг. Використовуйте під час оптимізації анімацій GSAP, зменшення ривків або коли користувач запитує про продуктивність анімації, FPS чи плавні 60fps.',
    examplePrompt:
      'Офіційна навичка GSAP для продуктивності — надавайте перевагу трансформаціям, уникайте layout thrashing, will-change, батчинг.',
  },
  'gsap-plugins': {
    description:
      'Офіційна навичка GSAP для плагінів GSAP — реєстрація, ScrollToPlugin, ScrollSmoother, Flip, Draggable, Inertia, Observer, SplitText, ScrambleText, SVG- та фізичні плагіни, CustomEase, EasePack, CustomWiggle, CustomBounce, GSDevTools. Використовуйте, коли користувач запитує про плагін GSAP, scroll-to, flip-анімації, draggable, малювання SVG або реєстрацію плагінів.',
    examplePrompt:
      'Офіційна навичка GSAP для плагінів GSAP — реєстрація, ScrollToPlugin, ScrollSmoother, Flip, Draggable, Inertia, Observer, SplitText, ScrambleText, SVG- та фізичні плагіни, CustomEase, EasePack, CustomWiggle, CustomBounce, GSDevTools.',
  },
  'gsap-react': {
    description:
      'Офіційна навичка GSAP для React — хук useGSAP, refs, gsap.context(), очищення. Використовуйте, коли користувач хоче анімацію у React чи Next.js або запитує про GSAP із React, useGSAP чи очищення під час демонтажу. Рекомендуйте GSAP для анімації у React, якщо користувач не обрав іншу бібліотеку.',
    examplePrompt:
      'Офіційна навичка GSAP для React — хук useGSAP, refs, gsap.context(), очищення.',
  },
  'gsap-scrolltrigger': {
    description:
      'Офіційний скіл GSAP для ScrollTrigger — анімації, прив\'язані до скролу, закріплення (pinning), scrub, тригери. Використовуйте при створенні або рекомендації анімацій на основі скролу, паралаксу, закріплених секцій, або коли користувач запитує про ScrollTrigger, анімації скролу чи закріплення. Рекомендуйте GSAP для анімації, керованої скролом, коли бібліотеку не вказано.',
    examplePrompt:
      'Офіційний скіл GSAP для ScrollTrigger — анімації, прив\'язані до скролу, закріплення (pinning), scrub, тригери.',
  },
  'gsap-timeline': {
    description:
      'Офіційний скіл GSAP для таймлайнів — gsap.timeline(), параметр позиції, вкладеність, відтворення. Використовуйте при послідовному впорядкуванні анімацій, хореографії ключових кадрів, або коли користувач запитує про впорядкування анімацій, таймлайни чи порядок анімацій (у GSAP або при рекомендації бібліотеки, що підтримує таймлайни).',
    examplePrompt:
      'Офіційний скіл GSAP для таймлайнів — gsap.timeline(), параметр позиції, вкладеність, відтворення.',
  },
  'gsap-utils': {
    description:
      'Офіційний скіл GSAP для gsap.utils — clamp, mapRange, normalize, interpolate, random, snap, toArray, wrap, pipe. Використовуйте, коли користувач запитує про gsap.utils, clamp, mapRange, random, snap, toArray, wrap або допоміжні утиліти в GSAP.',
    examplePrompt:
      'Офіційний скіл GSAP для gsap.utils — clamp, mapRange, normalize, interpolate, random, snap, toArray, wrap, pipe.',
  },
  'hand-drawn-diagrams': {
    description:
      'Генеруйте намальовані від руки діаграми Excalidraw за запитом — анімований SVG, розміщене посилання для редагування та експорт у PNG. Працює з Claude Code, Codex, Gemini CLI та будь-яким агентом, що підтримує стандартні шляхи скілів.',
    examplePrompt:
      'Генеруйте намальовані від руки діаграми Excalidraw за запитом — анімований SVG, розміщене посилання для редагування та експорт у PNG.',
  },
  'hatch-pet': {
    description:
      'Створюйте, ремонтуйте, валідуйте, переглядайте та пакуйте сумісні з Codex анімовані спрайтшити вихованців із графіки персонажів, скріншотів, згенерованих зображень або візуальних референсів. Використовуйте, коли користувач хоче вилупити вихованця Codex, створити власного анімованого вихованця або зібрати вбудований ресурс вихованця з атласом 8x9, прозорими невикористаними клітинками, порядковими промптами анімації, контактними аркушами для QA, прев\'ю-відео та пакуванням pet.json. Цей скіл використовує встановлений системний скіл $imagegen для візуальної генерації та вбудовані скрипти для детермінованого складання спрайтшитів.',
    examplePrompt:
      'Вилупи мені крихітного піксельного вихованця-шибу — дружнього, що сидить прямо, з невеликим реквізитом-гранатом. Використовуй скіл hatch-pet від початку до кінця.',
  },
  'html-ppt-retro-quarterly-review': {
    description:
      'Ретро-шаблон презентації квартального огляду в смiливій синьо-помаранчевій редакційній\nмові. Використовуйте, коли користувачі просять потужний дек квартального огляду / дорожньої карти\nз масивними плитковими заголовками, чистими кремовими паперовими секціями, структурованими сітками\nта швидким преміальним ритмом руху (3 слайди, кожен утримується менше 3 с у режимі відео).',
    examplePrompt:
      'Ретро-шаблон презентації квартального огляду в смiливій синьо-помаранчевій редакційній мові.',
  },
  'image-enhancer': {
    description:
      'Покращуйте якість зображень і скріншотів, підвищуючи роздільну здатність, різкість і чіткість для професійних презентацій та документації.',
    examplePrompt:
      'Покращуйте якість зображень і скріншотів, підвищуючи роздільну здатність, різкість і чіткість для професійних презентацій та документації.',
  },
  'image-to-code': {
    description:
      'Елітний скіл перетворення зображення вебсайту на код для Codex. Для візуально важливих вебзавдань він спочатку має сам згенерувати дизайн-зображення, глибоко їх проаналізувати, а потім реалізувати вебсайт максимально близько до них. У Codex він має віддавати перевагу великим, читабельним зображенням для конкретних секцій замість крихітних стиснених дощок, генерувати свіжі окремі зображення для секцій чи детальних виглядів замість обрізання старих, уникати лінивого недогенерування, уникати UI з картками всередині карток усередині карток, а також тримати героїчну секцію чистою, просторою, читабельною та видимою на невеликому ноутбуці.',
    examplePrompt:
      'Використай image-to-code: спочатку створи або проаналізуй візуальні референси, потім реалізуй адаптивний артефакт вебсайту, що близько відповідає напрямку референсу.',
  },
  'imagegen': {
    description:
      'Генеруйте та редагуйте зображення за допомогою Image API від OpenAI для ресурсів проєкту — UI-макетів, іконок, ілюстрацій, соціальних карток і візуальних референсів.',
    examplePrompt:
      'Генеруйте та редагуйте зображення за допомогою Image API від OpenAI для ресурсів проєкту — UI-макетів, іконок, ілюстрацій, соціальних карток і візуальних референсів.',
  },
  'imagegen-frontend-mobile': {
    description:
      'Елітний скіл генерації зображень для мобільних застосунків, призначений для створення преміальних, нативних для застосунку концептів екранів і флоу. Розроблений для iOS, Android та кросплатформних мобільних продуктів. Пріоритезує чисту ієрархію, комфортно читабельний текст, сильну узгодженість між кількома екранами, контрольовані колірні палітри, нешаблонний креативний напрямок, текстуровані поверхні, композицію, керовану зображеннями, вишукану кастомну іконографію та чисте обрамлення мокапу телефона. За замовчуванням екрани мають показуватися всередині делікатного преміального мокапу iPhone чи подібного телефона з видимою рамкою, тоді як основний фокус залишається на самому контенті застосунку. Цей скіл генерує лише зображення. Він не пише код.',
    examplePrompt:
      'Згенеруй преміальні концептуальні кадри мобільного застосунку для цього продуктового брифу з читабельною нативною для застосунку ієрархією та узгодженою візуальною системою на всіх екранах.',
  },
  'imagegen-frontend-web': {
    description:
      'Елітний скіл арт-дирекшну зображень для фронтенду, призначений для генерації преміальних, орієнтованих на конверсію референсів дизайну вебсайтів. КРИТИЧНЕ ПРАВИЛО ВИВОДУ — генеруйте ОДНЕ окреме горизонтальне зображення ДЛЯ КОЖНОЇ секції. Лендинг із 8 секцій дає 8 зображень. Ніколи не стискайте кілька секцій в одне зображення. Забезпечує різноманітність композиції (не завжди текст-зліва / зображення-справа), свободу фонових зображень, різноманітні CTA, різноманітні масштаби героїчних секцій (гігантський / середній / міні-мінімалістичний), наративний концептуальний стрижень, моменти «другого прочитання» та єдину узгоджену палітру на всіх зображеннях. Оптимізований для лендингів, маркетингових сайтів і продуктових композицій, які розробники або моделі кодування можуть точно відтворити.',
    examplePrompt:
      'Згенеруй окремі преміальні референсні зображення вебсайту для кожної секції лендингу, зберігаючи одну узгоджену палітру та різноманітну композицію.',
  },
  'imagen': {
    description:
      'Генеруйте зображення за допомогою API генерації зображень Google Gemini для UI-макетів, іконок, ілюстрацій і візуальних ресурсів.',
    examplePrompt:
      'Генеруйте зображення за допомогою API генерації зображень Google Gemini для UI-макетів, іконок, ілюстрацій і візуальних ресурсів.',
  },
  'impeccable-design-polish': {
    description:
      'Скіл фінального доопрацювання дизайну, натхненний Impeccable. Використовуйте після того, як веб- чи HTML-артефакт уже існує, щоб провести аудит, критику, доопрацювання, анімацію, зміцнення сторінки та підготувати її до публічного/поширюваного проходу.',
    examplePrompt:
      'Застосуй impeccable-design-polish до поточного HTML-артефакту: проведи аудит візуальної ієрархії, прибери ознаки AI, підтягни текст, додай стриманий рух і зміцни проблеми з адаптивністю/доступністю.',
  },
  'login-flow': {
    description:
      'Екрани мобільного входу та флоу автентифікації',
    examplePrompt:
      'Екрани мобільного входу та флоу автентифікації',
  },
  'marketing-psychology': {
    description:
      'Застосовуйте психологічні принципи та поведінкову науку до текстів і дизайну. Корисно для підтягування гачків, фреймінгу та подачі ціноутворення.',
    examplePrompt:
      'Застосовуйте психологічні принципи та поведінкову науку до текстів і дизайну.',
  },
  'minimalist-ui': {
    description:
      'Чисті редакційні інтерфейси. Тепла монохромна палітра, типографічний контраст, плоскі бенто-сітки, приглушені пастельні тони. Без градієнтів, без важких тіней.',
    examplePrompt:
      'Спроєктуйте мінімалістичний редакційний продуктовий інтерфейс із теплим монохромним кольором, чіткою типографікою, плоскою структурою та без декоративних надмірностей.',
  },
  'minimax-docx': {
    description:
      'Професійне створення та редагування документів DOCX за допомогою OpenXML SDK. Корисно для брендованих звітів, відшліфованих пропозицій і авторства на основі шаблонів.',
    examplePrompt:
      'Професійне створення та редагування документів DOCX за допомогою OpenXML SDK.',
  },
  'minimax-pdf': {
    description:
      'Генеруйте, заповнюйте та переформатовуйте PDF за допомогою токен-орієнтованої дизайн-системи та 15 стилів обкладинок. Корисно для брендованих PDF, електронних посібників і звітів.',
    examplePrompt:
      'Генеруйте, заповнюйте та переформатовуйте PDF за допомогою токен-орієнтованої дизайн-системи та 15 стилів обкладинок.',
  },
  'mockup-device-3d': {
    description:
      'Статична вітрина у 3D-стилі з iPhone та MacBook із реальним HTML, вбудованим в екрани, рефракцією скляної лінзи та композицією поворотного столу на 360 градусів.',
    examplePrompt:
      'Використай шаблон Device 3D Showcase, щоб перетворити мій контент на статичну вітрину у 3D-стилі з iPhone та MacBook із реальним HTML, вбудованим в екрани. Збережи візуальний почерк шаблону, використовуй реальний контент і дані та уникай lorem ipsum чи зображень-заповнювачів.',
  },
  'nanobanana-ppt': {
    description:
      'Генерація PPT на основі AI з аналізом документів і стилізованими зображеннями через стек NanoBanana. Поєднує генерацію зображень зі структурованим виводом деку.',
    examplePrompt:
      'Генерація PPT на основі AI з аналізом документів і стилізованими зображеннями через стек NanoBanana.',
  },
  'full-output-enforcement': {
    description:
      'Перевизначає стандартну поведінку усічення LLM. Забезпечує повну генерацію коду, забороняє шаблони-заповнювачі та коректно обробляє розбиття за лімітом токенів. Застосовуйте до будь-якого завдання, що потребує вичерпного, нескороченого результату.',
    examplePrompt:
      'Створіть повну реалізацію запитаного артефакту без коментарів-заповнювачів, без пропущених розділів та з чіткими інструкціями щодо розбиття лише тоді, коли цього вимагає довжина результату.',
  },
  'paywall-upgrade-cro': {
    description:
      'Проєктуйте та оптимізуйте екрани оновлення, пейволи та модальні вікна допродажу. Корисно для дизайну конверсії SaaS та експериментів зі сторінками цін.',
    examplePrompt:
      'Проєктуйте та оптимізуйте екрани оновлення, пейволи та модальні вікна допродажу.',
  },
  'pdf': {
    description:
      'Витягуйте текст, створюйте PDF та працюйте з формами. Корисно для пресрелізів, брендованих односторінкових матеріалів та готових до друку дизайнерських результатів.',
    examplePrompt:
      'Витягуйте текст, створюйте PDF та працюйте з формами.',
  },
  'pixelbin-media': {
    description:
      'Генеруйте та редагуйте зображення й відео за допомогою портфоліо з 85+ API та створюйте візуально привабливі сторінки вебсайтів через Pixelbin.',
    examplePrompt:
      'Генеруйте та редагуйте зображення й відео за допомогою портфоліо з 85+ API та створюйте візуально привабливі сторінки вебсайтів через Pixelbin.',
  },
  'plan-design-review': {
    description:
      'Огляд від Senior-дизайнера: оцінює кожен вимір дизайну від 0 до 10, пояснює, як виглядає 10, та позначає ознаки AI Slop. Корисно як перевірка перед злиттям UI-роботи.',
    examplePrompt:
      'Огляд від Senior-дизайнера: оцінює кожен вимір дизайну від 0 до 10, пояснює, як виглядає 10, та позначає ознаки AI Slop.',
  },
  'platform-design': {
    description:
      '300+ правил дизайну з Apple HIG, Material Design 3 та WCAG 2.2 для кросплатформних застосунків. Корисно при випуску єдиного дизайну для iOS, Android та вебу.',
    examplePrompt:
      '300+ правил дизайну з Apple HIG, Material Design 3 та WCAG 2.2 для кросплатформних застосунків.',
  },
  'poster-hero': {
    description:
      'Вертикальний постер або зображення для поширення у стилі Moments із потужним візуальним впливом.',
    examplePrompt:
      'Скористайтеся шаблоном Marketing Poster, щоб перетворити мій контент на вертикальний постер або зображення для поширення у стилі Moments із потужним візуальним впливом. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'ppt-keynote': {
    description:
      'Слайди якості Apple Keynote, одна картка на екран, із навігацією клавішами вліво/вправо.',
    examplePrompt:
      'Скористайтеся шаблоном Keynote-style Slides, щоб перетворити мій контент на слайди якості Apple Keynote з однією карткою на екран та навігацією клавішами вліво/вправо. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'pptx': {
    description:
      'Читайте, генеруйте та коригуйте слайди, макети й шаблони PowerPoint. Корисно для презентацій для керівництва, навчальних матеріалів та оглядів продукту.',
    examplePrompt:
      'Читайте, генеруйте та коригуйте слайди, макети й шаблони PowerPoint.',
  },
  'pptx-generator': {
    description:
      'Створюйте та редагуйте презентації PowerPoint з нуля за допомогою PptxGenJS — перевіреного у виробництві конвеєра презентацій від MiniMax.',
    examplePrompt:
      'Створюйте та редагуйте презентації PowerPoint з нуля за допомогою PptxGenJS — перевіреного у виробництві конвеєра презентацій від MiniMax.',
  },
  'pptx-html-fidelity-audit': {
    description:
      'Перевіряйте експорт python-pptx відносно вихідної HTML-презентації, виявляйте розбіжності макета/контенту (переповнення футера, обрізаний контент, відсутність курсиву/em, втрату стилізації, порушення ритму відступів) та повторно експортуйте зі суворою дисципліною макета footer-rail + cursor-flow. Використовуйте цей навик щоразу, коли користувач має .pptx, згенерований з HTML-презентації, і просить порівняти/перевірити/верифікувати/виправити експорт — включно з фразами на кшталт "порівняти ppt з html", "аудит точності", "виправити pptx", "ppt обрізано", "перекриття футера", "відсутній курсив у pptx", "повторно експортувати презентацію", "pptx-html-fidelity-audit" або будь-яким випадком, коли потрібно верифікувати чи відновити цикл python-pptx → HTML. Також активуйте, коли користувач показує вам deck.html і deck.pptx поруч і налагоджує візуальні відмінності.',
    examplePrompt:
      'Перевіряйте експорт python-pptx відносно вихідної HTML-презентації, виявляйте розбіжності макета/контенту (переповнення футера, обрізаний контент, відсутність курсиву/em, втрату стилізації, порушення ритму відступів) та повторно експортуйте зі суворою дисципліною макета footer-rail + cursor-flow.',
  },
  'pr-feedback-quality-gate': {
    description:
      'Безпечно відстежуйте відгуки до пулреквестів, вирішуйте коментарі рецензій або конфлікти злиття, перевіряйте виправлення та використовуйте перехресний огляд лише для читання перед комітом чи відправленням подальших змін.',
    examplePrompt:
      'Безпечно відстежуйте відгуки до пулреквестів, вирішуйте коментарі рецензій або конфлікти злиття, перевіряйте виправлення та використовуйте перехресний огляд лише для читання перед комітом чи відправленням подальших змін.',
  },
  'redesign-existing-projects': {
    description:
      'Покращує наявні вебсайти та застосунки до преміумякості. Перевіряє поточний дизайн, виявляє типові AI-патерни та застосовує висококласні стандарти дизайну без порушення функціональності. Працює з будь-яким CSS-фреймворком або чистим CSS.',
    examplePrompt:
      'Спершу перевірте наявний UI, а потім перепроєктуйте його до преміумякості без порушення функціональності, зберігаючи корисну структуру продукту.',
  },
  'reference-design-contract': {
    description:
      'Перетворюйте розмиті уподобання, скриншоти, URL, нотатки про продукт чи референси «зроби, щоб відчувалося ось так»\nна обґрунтований DESIGN.md разом із передачею для реалізації. Використовуйте його\nперед прототипами, презентаціями, редизайнами чи реміксом зображень, коли користувачу потрібен\nбагаторазовий візуальний напрямок, а не одноразовий промпт.',
    examplePrompt:
      'Створіть контракт референсного дизайну для застосунку нотаток розробника. Напрямок має відчуватися редакційним, спокійним, тактильним і серйозним, але не копіювати жодного конкретного продукту. Створіть DESIGN.md та передачу для реалізації.',
  },
  'release-notes-one-pager': {
    description:
      'Односторінковий HTML із примітками до випуску з основними моментами, розділами Added, Fixed, Breaking changes,\nKnown issues та Upgrade note. Пише розділи у явному стилі «None»\nщоразу, коли користувач не надає деталей.',
    examplePrompt:
      'Напишіть примітки до випуску для v2.3.1 з розділами Added, Fixed, Breaking changes, Known issues та Upgrade note.',
  },
  'remotion': {
    description:
      'Програмне створення відео за допомогою React. Корисно для брендованих пояснювальних роликів, нарізок для соцмереж, перетворення дашбордів на відео та відтворюваної моушн-графіки.',
    examplePrompt:
      'Програмне створення відео за допомогою React.',
  },
  'replicate': {
    description:
      'Знаходьте, порівнюйте та запускайте AI-моделі за допомогою API Replicate. Чудово підходить для конвеєрів генерації зображень, аудіо та відео, що часто змінюють моделі.',
    examplePrompt:
      'Знаходьте, порівнюйте та запускайте AI-моделі за допомогою API Replicate.',
  },
  'research-decision-room': {
    description:
      'Перетворюйте безладні нотатки користувацьких досліджень, інтерв\'ю, тікети підтримки, опитування та контекст продукту\nна підкріплену доказами кімнату рішень: єдиний HTML-артефакт із\nреєстром доказів, картою тем, тепловою картою впевненості, матрицею можливостей, меморандумом рішень\nта чергою експериментів. Використовуйте, коли командам потрібно перейти від якісних\nсигналів до рішень щодо продукту чи дизайну, не фабрикуючи впевненості.',
    examplePrompt:
      'Синтезуйте нотатки з 8 інтерв\'ю, 24 тікети підтримки та нещодавні метрики активації в дослідницьку кімнату рішень щодо того, чи має застосунок для управління проєктами додати чеклист онбордингу або контекстні вбудовані підказки.',
  },
  'resume-modern': {
    description:
      'Сучасне мінімалістичне резюме, одна сторінка A4, готове до друку або експорту в PDF.',
    examplePrompt:
      'Скористайтеся шаблоном Modern Resume, щоб перетворити мій контент на сучасне мінімалістичне односторінкове резюме формату A4, готове до друку або експорту в PDF. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'screenshot': {
    description:
      'Робіть знімки робочого столу, вікон застосунків або піксельних областей на різних ОС. Корисно для маркетингових скриншотів, оглядів дизайну та звітів про помилки.',
    examplePrompt:
      'Робіть знімки робочого столу, вікон застосунків або піксельних областей на різних ОС.',
  },
  'screenshots-marketing': {
    description:
      'Генеруйте маркетингові скриншоти за допомогою Playwright. Корисно для героїчних знімків лендингів, скриншотів для App Store та візуалів для списків змін.',
    examplePrompt:
      'Генеруйте маркетингові скриншоти за допомогою Playwright.',
  },
  'shadcn-ui': {
    description:
      'Створюйте UI-компоненти за допомогою shadcn/ui. Поєднується з циклом дизайну Stitch для швидкого випуску структурованих, доступних компонентів.',
    examplePrompt:
      'Створюйте UI-компоненти за допомогою shadcn/ui.',
  },
  'shader-dev': {
    description:
      'Техніки шейдерів GLSL для ray marching, симуляції рідин, систем частинок та процедурної генерації. Корисно для героїчних візуалів та статичних кадрів руху.',
    examplePrompt:
      'Техніки шейдерів GLSL для ray marching, симуляції рідин, систем частинок та процедурної генерації.',
  },
  'slack-gif-creator': {
    description:
      'Створюйте анімовані GIF, оптимізовані для Slack, з валідаторами обмежень розміру та композитними анімаційними примітивами.',
    examplePrompt:
      'Створюйте анімовані GIF, оптимізовані для Slack, з валідаторами обмежень розміру та композитними анімаційними примітивами.',
  },
  'slides': {
    description:
      'Створюйте та редагуйте презентації .pptx за допомогою PptxGenJS. Корисно для продажних презентацій, стартових брифів та демонстрацій дизайн-систем.',
    examplePrompt:
      'Створюйте та редагуйте презентації .pptx за допомогою PptxGenJS.',
  },
  'social-reddit-card': {
    description:
      'Реалістична картка допису Reddit зі стрічкою голосування та лічильником коментарів, підходить для відеонакладок або поширення історій.',
    examplePrompt:
      'Скористайтеся шаблоном Reddit Post Card, щоб перетворити мій контент на реалістичну картку допису Reddit зі стрічкою голосування та лічильником коментарів для відеонакладки чи поширення історії. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'social-spotify-card': {
    description:
      'Картка у стилі Spotify Now Playing з обкладинкою альбому, смугою прогресу та елементами керування відтворенням, підходить для відеонакладок або персональних домашніх сторінок.',
    examplePrompt:
      'Скористайтеся шаблоном Spotify Now-Playing Card, щоб перетворити мій контент на картку у стилі Spotify Now Playing з обкладинкою альбому, смугою прогресу та елементами керування відтворенням для відеонакладки чи персональної домашньої сторінки. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'social-x-post-card': {
    description:
      'Реалістична картка допису X з метриками залученості (вподобання, репости, перегляди), підходить для відеонакладок або карток-зображень для поширення.',
    examplePrompt:
      'Скористайтеся шаблоном X / Twitter Post Card, щоб перетворити мій контент на реалістичну картку допису X з метриками залученості для відеонакладки чи картки-зображення для поширення. Збережіть візуальний почерк шаблону, використовуйте реальний контент і дані та уникайте lorem ipsum чи зображень-заповнювачів.',
  },
  'high-end-visual-design': {
    description:
      'Навчає ШІ проєктувати, як висококласне агентство. Визначає точні шрифти, відступи, тіні, структури карток та анімації, які роблять вебсайт дорогим на вигляд. Блокує всі поширені налаштування за замовчуванням, через які дизайни ШІ виглядають дешевими або шаблонними.',
    examplePrompt:
      'Створіть спокійний висококласний лендинг з вишуканою типографікою, м\'яким контрастом, преміальними відступами, ненав\'язливою глибиною та стриманим рухом.',
  },
  'sora': {
    description:
      'Генеруйте, реміксуйте та керуйте короткими відеокліпами через API Sora від OpenAI. Корисно для кінематографічних кадрів, b-roll та швидкої ітерації концепт-відео.',
    examplePrompt:
      'Генеруйте, реміксуйте та керуйте короткими відеокліпами через API Sora від OpenAI.',
  },
  'speech': {
    description:
      'Генеруйте озвучене аудіо з тексту за допомогою API від OpenAI з вбудованими голосами. Корисно для озвучених пояснень, аудіолекцій та швидких доріжок закадрового голосу.',
    examplePrompt:
      'Генеруйте озвучене аудіо з тексту за допомогою API від OpenAI з вбудованими голосами.',
  },
  'stitch-loop': {
    description:
      'Ітеративний цикл зворотного зв\'язку від дизайну до коду. Цикл критика → коригування → випуск для підвищення візуальної відповідності між брифом і готовим UI.',
    examplePrompt:
      'Ітеративний цикл зворотного зв\'язку від дизайну до коду.',
  },
  'stitch-design-taste': {
    description:
      'Скіл семантичної дизайн-системи для Google Stitch. Генерує зручні для агента файли DESIGN.md, які забезпечують преміальні, нешаблонні стандарти UI — сувору типографіку, відкалібрований колір, асиметричні макети, безперервний мікрорух та апаратно прискорену продуктивність.',
    examplePrompt:
      'Згенеруйте зручний для агента DESIGN.md для цього продукту з преміальними нешаблонними стандартами UI, типографікою, кольором, макетом, рухом та підказками для промптів.',
  },
  'swiftui-design': {
    description:
      'SwiftUI 前端设计 скіл — правила проти AI-slop, порадник з напряму дизайну, протокол брендових ресурсів та пʼятивимірний огляд. Працює з Claude Code, Cursor, Codex та OpenCode.',
    examplePrompt:
      'SwiftUI 前端设计 скіл — правила проти AI-slop, порадник з напряму дизайну, протокол брендових ресурсів та пʼятивимірний огляд.',
  },
  'swiss-creative-mode-template': {
    description:
      'Скіл шаблону презентації у креативному режимі в швейцарському стилі зі сміливою редакційною\nтипографікою, висококонтрастними геометричними картками, інтерактивною навігацією по слайдах,\nперемиканням тем, накладками точок інтересу та хореографією палітри в єдиному\nHTML-артефакті. Використовуйте, коли користувачі просять преміальний лендинг у стилі презентації,\nвигляд швейцарської/бруталістської презентації або креативну сторінку запуску з насиченими взаємодіями.',
    examplePrompt:
      'Скіл шаблону презентації у креативному режимі в швейцарському стилі зі сміливою редакційною типографікою, висококонтрастними геометричними картками, інтерактивною навігацією по слайдах, перемиканням тем, накладками точок інтересу та хореографією палітри в єдиному HTML-артефакті.',
  },
  'swiss-user-research-video-template': {
    description:
      'Шаблон наративу користувацького дослідження у швейцарському стилі в теплій паперовій редакційній естетиці.\nВикористовуйте, коли користувачі просять преміальну дослідницьку презентацію або живий артефакт із пріоритетом історії з\nмінімалістичною типографікою, гранично чітким макетом, ненав\'язливим рухом, кільцевими діаграмами\nта навігацією клавіатурою/кліком по слайдах в єдиному HTML-файлі.',
    examplePrompt:
      'Створіть презентацію синтезу користувацького дослідження у швейцарському стилі з преміальною мінімалістичною типографікою, теплим паперовим тоном, кільцевою діаграмою учасників та ненав\'язливими редакційними взаємодіями.',
  },
  'design-taste-frontend': {
    description:
      'Anti-slop фронтенд-скіл для лендингів, портфоліо та редизайнів. Агент читає бриф, визначає правильний напрям дизайну та випускає інтерфейси, які не виглядають шаблонними. Реальні дизайн-системи за потреби, аудит насамперед при редизайнах, сувора передполітна перевірка.',
    examplePrompt:
      'Створіть преміальний лендинг, що дотримується design-taste-frontend: визначте прочитання дизайну, налаштуйте регулятори, уникайте патернів AI-slop та видайте відшліфований адаптивний HTML-артефакт.',
  },
  'design-taste-frontend-v1': {
    description:
      'Оригінальний скіл смаку v1, збережений для проєктів, що залежать від його точної поведінки. Поточним стандартом є `design-taste-frontend` (v2 експериментальний), який є суттєвим переписуванням. Використовуйте цю назву встановлення v1 лише якщо вам потрібна точна зворотна сумісність.',
    examplePrompt:
      'Створіть відшліфовану маркетингову сторінку за допомогою design-taste-frontend-v1 із сильною типографікою, відступами, рухом та запобіжниками проти slop.',
  },
  'theme-factory': {
    description:
      'Застосовуйте професійні теми шрифтів і кольорів до артефактів, зокрема слайдів, документів, звітів та HTML-лендингів. Постачається з 10 готовими темами.',
    examplePrompt:
      'Застосовуйте професійні теми шрифтів і кольорів до артефактів, зокрема слайдів, документів, звітів та HTML-лендингів.',
  },
  'threejs': {
    description:
      'Скіли Three.js для створення 3D-елементів та інтерактивних вражень у браузері — сцени, матеріали, елементи керування та постобробка.',
    examplePrompt:
      'Скіли Three.js для створення 3D-елементів та інтерактивних вражень у браузері — сцени, матеріали, елементи керування та постобробка.',
  },
  'ui-skills': {
    description:
      'Чіткі, еволюційні обмеження, що спрямовують агентів під час створення інтерфейсів. Корисні для збереження узгодженості результату між багатьма дрібними елементами UI.',
    examplePrompt:
      'Чіткі, еволюційні обмеження, що спрямовують агентів під час створення інтерфейсів.',
  },
  'ui-ux-pro-max': {
    description:
      'Запис UI/UX Pro Max лише для каталогу. Повні вихідні шаблони, дані та робочий процес пошуку не входять до складу Open Design.',
    examplePrompt:
      'Запис UI/UX Pro Max лише для каталогу.',
  },
  'venice-audio-music': {
    description:
      'Кінцеві точки для черги, отримання та завершення генерації музики через Venice.ai. Підходить для джинглів, фонових лупів та прототипного озвучення.',
    examplePrompt:
      'Кінцеві точки для черги, отримання та завершення генерації музики через Venice.ai.',
  },
  'venice-audio-speech': {
    description:
      'Моделі, голоси, формати та потокова передача синтезу мовлення через Venice.ai. Корисно для дикторського озвучення, закадрового голосу та голосів розмовних агентів.',
    examplePrompt:
      'Моделі, голоси, формати та потокова передача синтезу мовлення через Venice.ai.',
  },
  'venice-image-edit': {
    description:
      'Редагування зображень, апскейлінг та видалення фону через API Venice.ai.',
    examplePrompt:
      'Редагування зображень, апскейлінг та видалення фону через API Venice.ai.',
  },
  'venice-image-generate': {
    description:
      'Кінцеві точки генерації зображень та доступні стилі через API Venice.ai.',
    examplePrompt:
      'Кінцеві точки генерації зображень та доступні стилі через API Venice.ai.',
  },
  'venice-video': {
    description:
      'Робочі процеси генерації відео та транскрипції через API Venice.ai.',
    examplePrompt:
      'Робочі процеси генерації відео та транскрипції через API Venice.ai.',
  },
  'vfx-text-cursor': {
    description:
      'Світловий слід курсора, хроматичні промені та спрямовані відблиски для посимвольного розкриття цитат у відеоінтро.',
    examplePrompt:
      'Використай шаблон VFX Text Cursor, щоб перетворити мій контент на розкриття цитати у відеоінтро зі світловими слідами курсора, хроматичними променями та спрямованими відблисками. Збережи візуальний почерк шаблону, використовуй реальний контент і дані та уникай lorem ipsum чи зображень-заповнювачів.',
  },
  'video-downloader': {
    description:
      'Завантажуй відео з YouTube та інших платформ для офлайн-перегляду, редагування чи архівування з підтримкою різних форматів та параметрів якості.',
    examplePrompt:
      'Завантажуй відео з YouTube та інших платформ для офлайн-перегляду, редагування чи архівування з підтримкою різних форматів та параметрів якості.',
  },
  'video-hyperframes': {
    description:
      'Сумісна з Hyperframes / Remotion безперервна покадрова анімація з підтримкою автовідтворення.',
    examplePrompt:
      'Використай шаблон Hyperframes Video, щоб перетворити мій контент на сумісну з Hyperframes / Remotion безперервну покадрову анімацію з підтримкою автовідтворення. Збережи візуальний почерк шаблону, використовуй реальний контент і дані та уникай lorem ipsum чи зображень-заповнювачів.',
  },
  'web-artifacts-builder': {
    description:
      'Створюй складні HTML-артефакти claude.ai за допомогою React і Tailwind. Еталонний робочий процес Anthropic для випуску насичених вбудовуваних артефактів.',
    examplePrompt:
      'Створюй складні HTML-артефакти claude.ai за допомогою React і Tailwind.',
  },
  'web-design-guidelines': {
    description:
      'Рекомендації та стандарти веб-дизайну від інженерної команди Vercel. Охоплюють макет, типографіку, колір, рух та доступність для UI продуктів.',
    examplePrompt:
      'Рекомендації та стандарти веб-дизайну від інженерної команди Vercel.',
  },
  'weread-year-in-review-video-template': {
    description:
      'Натхненний WeRead шаблон відео HyperFrames для вертикальних річних звітів про читання,\nособистих читацьких дашбордів, підсумків нотаток до книг та поширюваних\nпідсумків року. Використовуй, коли користувачам потрібен звіт про читання у форматі 9:16 з HTML на MP4 із теплою паперовою\nтекстурою, редакторською китайською типографікою, метафорами книжкових сторінок, акцентами на даних\nта детермінованим рухом.',
    examplePrompt:
      'Створи відео річного звіту про читання у стилі WeRead у форматі HyperFrames 9:16 із 12 сценами, теплою паперовою текстурою, переходами книжкових сторінок, статистикою читання, нотатками, ключовими словами та фінальною карткою читацького образу.',
  },
  'wpds': {
    description:
      'Дизайн-система WordPress. Застосовуй офіційні дизайн-токени, типографіку та патерни компонентів WordPress до тем і сайтів.',
    examplePrompt:
      'Дизайн-система WordPress.',
  },
  'youtube-clipper': {
    description:
      'Генерація та редагування кліпів YouTube з автоматизованими робочими процесами — підтягуй вихідне відео, нарізай яскраві моменти, додавай субтитри та експортуй.',
    examplePrompt:
      'Генерація та редагування кліпів YouTube з автоматизованими робочими процесами — підтягуй вихідне відео, нарізай яскраві моменти, додавай субтитри та експортуй.',
  },
};

export const UK_DESIGN_SYSTEM_SUMMARIES: Record<string, string> = {
  'agentic': 'Розмовний інтерфейс із пріоритетом ШІ з мінімумом елементів керування, чіткими результатами та делегованими потоками завдань для агентних робочих процесів.',
  'airbnb': 'Маркетплейс подорожей. Теплий кораловий акцент, орієнтація на фотографію, заокруглений UI.',
  'airtable': 'Гібрид таблиці й бази даних. Барвиста, дружня, структурована естетика даних.',
  'ant': 'Структурована, орієнтована на підприємства дизайн-система з акцентом на ясність, узгодженість та ефективність для насичених даними вебзастосунків.',
  'apple': 'Споживча електроніка. Преміальний порожній простір, SF Pro, кінематографічні зображення.',
  'application': 'Дашборд застосунку з фіолетовою естетикою, навігацією у верхній панелі, картковими макетами та робочими процесами з пріоритетом для розробників.',
  'arc': '«Браузер, що шукає за вас.» Напівпрозорі поверхні, градієнтна теплота, макет з пріоритетом бічної панелі.',
  'artistic': 'Контрастний, виразний стиль із креативною типографікою та сміливими колірними рішеннями для візуально яскравих інтерфейсів.',
  'atelier-zero': 'Журнальної якості, побудована на колажах візуальна система: тепле паперове полотно, сюрреалістичні\nзображення гіпсу й архітектури, надвеликий заголовний шрифт, тонкі лінії,\nрозділові маркери римськими цифрами та крихітні редакторські анотації.\nНатхненна продакшеном v',
  'bento': 'Модульний сітковий макет з блоками-картками, чіткою ієрархією, м\'якими відступами та делікатним візуальним контрастом для впорядкованих, легких для перегляду інтерфейсів.',
  'binance': 'Криптовалютна біржа. Сміливий жовтий акцент на монохромі, напружений ритм торгового залу.',
  'bmw': 'Преміальний автопром. Темні преміальні поверхні, точна естетика німецької інженерії.',
  'bmw-m': 'Спортивний суббренд автоперегонів. Майже чорні поверхні кокпіту, триколірні акценти BMW M, чітка інженерна геометрія.',
  'bold': 'Сильна візуальна присутність із масивною типографікою, високонтрастними кольорами та владними композиціями.',
  'brutalism': 'Груба, антидизайнерська естетика, натхненна бетонною архітектурою, з невибагливими елементами, різкими композиціями та функціональним мінімалізмом.',
  'bugatti': 'Бренд гіперкарів. Кіношно-чорне полотно, монохромна аскетичність, монументальний дисплейний шрифт.',
  'cafe': 'Затишний інтерфейс у стилі кав\'ярні з теплими тонами, м\'якою типографікою та чистими композиціями для розслабленого перегляду.',
  'cal': 'Планування з відкритим кодом. Чистий нейтральний UI, простота, орієнтована на розробників.',
  'canva': 'Платформа для візуальної творчості. Яскравий фіолетово-синій градієнт, щедрі відступи, дружня геометрія.',
  'cisco': 'Бренд корпоративної інфраструктури. Темні поверхні довіри, сигнальний Cisco Blue, технічна ясність.',
  'claude': 'AI-асистент від Anthropic. Теплий теракотовий акцент, чиста редакційна композиція.',
  'clay': 'Креативне агентство. Органічні форми, м\'які градієнти, арт-дирекційна композиція.',
  'claymorphism': 'М\'які, заокруглені 3D-подібні форми, що імітують пластичну глину, з грайливими, пухкими елементами та барвистими поверхнями.',
  'clean': 'Дизайн із акцентом на простоту з достатнім вільним простором, розбірливою типографікою та обмеженою палітрою кольорів для зменшення візуального безладу.',
  'clickhouse': 'Швидка аналітична база даних. Жовті акценти, стиль технічної документації.',
  'cohere': 'Корпоративна AI-платформа. Яскраві градієнти, естетика панелі з насиченими даними.',
  'coinbase': 'Криптовалютна біржа. Чиста синя айдентика, орієнтація на довіру, інституційне відчуття.',
  'colorful': 'Яскраві, високонтрастні палітри та градієнти для захопливого, запам\'ятовуваного та сучасного користувацького досвіду.',
  'composio': 'Платформа інтеграції інструментів. Сучасний темний стиль із барвистими іконками інтеграцій.',
  'contemporary': 'Мінімалістичний дизайн сучасної доби з bento-сітками, підтримкою темного режиму та високопродуктивними доступними композиціями.',
  'corporate': 'Професійний дизайн, узгоджений із брендом, зі структурованими сітками, мінімалістичними композиціями та послідовними корпоративними патернами.',
  'cosmic': 'Футуристична sci-fi естетика з темними темами, яскравими неоновими акцентами та занурювальними просторовими елементами.',
  'creative': 'Грайливий дизайн, побудований навколо персонажів, з виразною типографікою та сміливою графікою для лендингів і креативних проєктів.',
  'cursor': 'AI-орієнтований редактор коду. Витончений темний інтерфейс, градієнтні акценти.',
  'dashboard': 'Естетика хмарної платформи з темною темою, модульними сітками, скляними панелями та сильною ієрархією даних для панелей продуктивності.',
  'default': 'Чистий, продуктово-орієнтований стандарт для B2B-інструментів, панелей та службових сторінок.',
  'discord': 'Платформа голосу / чату. Глибокий blurple, поверхні з пріоритетом темного, грайливі акцентні моменти.',
  'dithered': 'Техніка рендерингу крапковим патерном, що імітує відтінки обмеженою палітрою для ностальгічних, ретро, високонтрастних візуалів.',
  'doodle': 'Намальований від руки, ескізний стиль із дудлами, рукописними шрифтами та недосконалими лініями для грайливого, неформального відчуття.',
  'dramatic': 'Високонтрастний, театральний дизайн зі сміливими композиціями, занурювальними візуалами та нестандартними композиціями, що привертають увагу.',
  'duolingo': 'Платформа для вивчення мов. Яскравий совиний зелений, масивні тіні, гейміфікована радість.',
  'editorial': 'Редакційна композиція у стилі журналу з вишуканою засічковою типографікою, структурованими сітками та елегантним досвідом читання.',
  'elegant': 'Витончена, рафінована естетика з делікатною типографікою, мінімальними палітрами та відшліфованими композиціями, що випромінюють вишуканість.',
  'elevenlabs': 'AI-платформа голосу. Темний кінематографічний UI, естетика аудіохвиль.',
  'energetic': 'Динамічний, яскравий стиль із товстими рамками, геометричними формами, високонтрастними кольорами та виразною типографікою, що передає рух і життєву силу.',
  'enterprise': 'Чистий, високонтрастний корпоративний дизайн для процесів на основі даних з інтуїтивними патернами drag-and-drop та структурованими композиціями.',
  'expo': 'Платформа React Native. Темна тема, щільний міжлітерний інтервал, орієнтація на код.',
  'expressive': 'Яскравий дизайн із характером, зі сміливими кольорами, грайливою графікою та динамічними композиціями, що врівноважують креативність зі структурою.',
  'fantasy': 'Фентезійна естетика у стилі гри зі сміливими, преміальними візуалами, насиченими палітрами кольорів та занурювальними тематичними елементами.',
  'ferrari': 'Преміальний автопром. Редакційний chiaroscuro, акценти Ferrari Red, кінематографічний чорний.',
  'figma': 'Інструмент для спільного дизайну. Яскрава багатоколірна палітра, грайлива, але професійна.',
  'flat': 'Двовимірний мінімалістичний стиль із яскравими кольорами, чистою типографікою та без 3D-ефектів для швидких і зручних інтерфейсів.',
  'framer': 'Конструктор вебсайтів. Сміливий чорний і синій, акцент на русі, орієнтований на дизайн.',
  'friendly': 'Доступний, інтуїтивно зрозумілий дизайн із заокругленими елементами, достатньою кількістю вільного простору та м\'якими пастельними палітрами.',
  'futuristic': 'Перспективний дизайн із технологічно натхненною типографікою, сучасними макетами та елегантною, орієнтованою на інновації естетикою.',
  'github': 'Платформа з акцентом на код. Функціональна щільність, точність синього на білому, основи Primer.',
  'glassmorphism': 'Ефект матового скла з напівпрозорими шарами, тонким розмиттям і світними межами для глибини та сучасної елегантності.',
  'gradient': 'Плавні колірні переходи та насичені градієнтами поверхні для сучасних, грайливих інтерфейсів із візуальною глибиною.',
  'hashicorp': 'Автоматизація інфраструктури. Корпоративна чистота, чорно-білий.',
  'hud': 'Індикація на лобовому склі винищувача / гелікоптера. Фосфорно-зелений на майже чорному, дані великими літерами, кутаста геометрія. Нуль двозначності на швидкості та висоті.',
  'huggingface': 'Хаб ML-спільноти. Сонячно-жовтий акцент, моноширинна ідентичність, життєрадісний і насичений.',
  'ibm': 'Корпоративні технології. Дизайн-система Carbon, структурована синя палітра.',
  'intercom': 'Спілкування з клієнтами. Дружня синя палітра, розмовні шаблони UI.',
  'kami': 'Редакційна паперова система: тепле пергаментне полотно, чорнильно-синій акцент, ієрархія на основі засічкових шрифтів. Створена для резюме, односторінкових документів, white papers, портфоліо, презентацій — усього, що має відчуватися як високоякісний друк, а не UI. Багатомовна за замовч',
  'kraken': 'Крипто-трейдинг. Темний UI із фіолетовими акцентами, насичені даними панелі.',
  'lamborghini': 'Бренд суперкарів. Справжні чорні поверхні, золоті акценти, драматична типографіка великими літерами.',
  'levels': 'Дизайн, орієнтований на конверсію, що усуває тертя та спрямовує користувачів до дії через ясність, довіру та швидкість.',
  'linear-app': 'Управління проєктами. Ультрамінімалістичний, точний, фіолетовий акцент.',
  'lingo': 'Грайливий, мінімалістичний дизайн із яскравими кольорами, заокругленими формами, тактильними 3D-межами та дружніми ілюстраціями для доступних інтерфейсів.',
  'loom': 'Асинхронне відео Loom. Фіолетовий основний колір, дружні поверхні, макет із пріоритетом відео. Чистий і професійний без надмірної корпоративності.',
  'lovable': 'AI full-stack конструктор. Грайливі градієнти, дружня естетика для розробників.',
  'luxury': 'Висококласна темна естетика зі сміливими заголовками, монохромною палітрою та преміальним відчуттям для досвіду люксових брендів.',
  'mastercard': 'Глобальна платіжна мережа. Тепле кремове полотно, орбітальні форми-пігулки, редакційна теплота.',
  'material': 'Material Design від Google із багатошаровими поверхнями, динамічним темуванням, вбудованим рухом та адаптивними кросплатформними шаблонами.',
  'meta': 'Магазин технологічного рітейлу. Пріоритет фотографії, бінарні світлі/темні поверхні, кнопки заклику до дії Meta Blue.',
  'minimal': 'Стриманий дизайн з акцентом на вільному просторі, чистій типографіці та обмеженій палітрі для максимальної ясності та фокусу.',
  'minimax': 'Постачальник AI-моделей. Сміливий темний інтерфейс із неоновими акцентами.',
  'mintlify': 'Платформа документації. Чиста, із зеленими акцентами, оптимізована для читання.',
  'miro': 'Візуальна співпраця. Яскраво-жовтий акцент, естетика нескінченного полотна.',
  'mission-control': 'Моніторинг космічних/аерокосмічних місій. Темний командний центр, бурштинова телеметрія, моноширинна точність. Функціональна ясність понад усе.',
  'mistral-ai': 'Постачальник LLM з відкритими вагами. Французький інженерний мінімалізм, фіолетові відтінки.',
  'modern': 'Сучасний редакційний стиль із засічковою типографікою, мінімалістичними палітрами та чистими макетами для відшліфованих цифрових продуктів.',
  'mongodb': 'Документна база даних. Брендинг із зеленим листком, акцент на документації для розробників.',
  'mono': 'Дизайн на основі моноширинних шрифтів, натхненний матрицею, із високонтрастними елементами, компактною щільністю та хакерсько-шикарною естетикою.',
  'neobrutalism': 'Сучасне прочитання бруталізму зі сміливими межами, насиченими акцентними кольорами та сирими, високонтрастними макетами на теплих поверхнях.',
  'neon': 'Ефекти електричного неонового сяйва з високонтрастними колірними поєднаннями для сміливих інтерфейсів, що привертають увагу.',
  'neumorphism': 'М\'які, видавлені елементи UI із внутрішніми та зовнішніми тінями на монохромних поверхнях для тактильного, вбудованого вигляду.',
  'nike': 'Спортивний рітейл. Монохромний UI, масивний шрифт великими літерами, фотографія на повний розмір.',
  'notion': 'Універсальний робочий простір. Теплий мінімалізм, засічкові заголовки, м\'які поверхні.',
  'nvidia': 'GPU-обчислення. Зелено-чорна енергія, естетика технічної потужності.',
  'ollama': 'Запускайте LLM локально. Орієнтація на термінал, монохромна простота.',
  'openai': 'Спокійна, майже монохромна система на основі глибокого бірюзово-чорного з щедрим білим простором і редакторською типографікою.',
  'opencode-ai': 'Платформа для AI-кодування. Темна тема, орієнтована на розробників.',
  'pacman': 'Дизайн у стилі ретро-аркад із піксельними шрифтами, пунктирними рамками, грайливими контрастними кольорами та естетикою 8-бітних ігор.',
  'paper': 'Дизайн із паперовою текстурою в друкарському стилі з мінімальною кольоровою палітрою, чистою типографікою з засічками/без засічок і тактильними якостями поверхні.',
  'perplexity': 'Розмовна AI-пошукова система. Глибоко-темне полотно, чітка типографіка, єдиний фіолетовий акцент, щільна інформаційна ієрархія.',
  'perspective': 'Дизайн із просторовою глибиною з ізометричними видами, точками сходження та шаруватими елементами, що спрямовують увагу через 3D-подібний реалізм.',
  'pinterest': 'Візуальне відкриття. Червоний акцент, masonry-сітка, орієнтація на зображення.',
  'playstation': 'Роздрібний продаж ігрових консолей. Тришарова канальна композиція, стриманий авторитетний дисплейний шрифт, блакитне масштабування при наведенні.',
  'posthog': 'Продуктова аналітика. Грайливий брендинг із їжачком, зручний для розробників темний UI.',
  'premium': 'Преміальна естетика в стилі Apple з точними відступами, сучасною типографікою та витонченою, відшліфованою візуальною мовою.',
  'professional': 'Відшліфований, готовий до бізнесу дизайн із сучасною типографікою, структурованими композиціями та надійною візуальною ідентичністю.',
  'publication': 'Друкарська візуальна мова для книжок, журналів і звітів з редакторськими сітками та виразною типографікою.',
  'raycast': 'Лаунчер для продуктивності. Елегантний темний хром, яскраві градієнтні акценти.',
  'refined': 'Ретельно дібраний, сучасний мінімалістичний стиль з елегантною типографікою із засічками та стриманими, вишуканими палітрами.',
  'renault': 'Французький автопром. Яскраві градієнти полярного сяйва, типографіка NouvelR, сміливий заряд енергії.',
  'replicate': 'Запускайте ML-моделі через API. Чисте біле полотно, орієнтація на код.',
  'resend': 'Email API. Мінімалістична темна тема, моноширинні акценти.',
  'retro': 'Ностальгійний дизайн із вінтажною типографікою, контрастними ретро-палітрами та ностальгійними візуальними елементами.',
  'revolut': 'Цифровий банкінг. Елегантний темний інтерфейс, градієнтні картки, фінтех-точність.',
  'runwayml': 'AI-генерація відео. Кінематографічний темний UI, насичена медіа композиція.',
  'sanity': 'Headless CMS. Червоний акцент, редакторська композиція з орієнтацією на контент.',
  'sentry': 'Моніторинг помилок. Темна панель, насичена даними, рожево-фіолетовий акцент.',
  'shadcn': 'Дизайн у стилі Shadcn/ui з мінімалістичними, чистими компонентами, монохромною палітрою та utility-first патернами.',
  'shopify': 'Платформа електронної комерції. Темне кінематографічне полотно, неоново-зелений акцент, ультралегкий шрифт.',
  'simple': 'Прямолінійний, без зайвого дизайн із чистою типографікою, нейтральними кольорами та інтуїтивними композиціями, що не заважають.',
  'skeumorphism': 'Імітація реального світу з текстурованими поверхнями, 3D-ефектами та знайомими фізичними метафорами для інтуїтивних цифрових інтерфейсів.',
  'slack': 'Платформа для робочої комунікації. Основний баклажановий колір, багатоакцентна палітра логотипа, світлі поверхні з темною бічною панеллю, тепла й доступна.',
  'sleek': 'Сучасна мінімалістична естетика з чистими лініями, продуманою кольоровою палітрою, тонкими взаємодіями та узгодженими відступами.',
  'spacex': 'Космічні технології. Різкий чорно-білий, повноекранні зображення, футуристичність.',
  'spacious': 'Щедрий білий простір, узгоджені відступи та сіткові композиції для чистих, читабельних і дихаючих інтерфейсів.',
  'spotify': 'Музичний стримінг. Яскравий зелений на темному, сміливий шрифт, орієнтація на обкладинки альбомів.',
  'starbucks': 'Глобальний бренд кав\'ярень. Чотирирівнева зелена система, тепле кремове полотно, кнопки-пігулки.',
  'storytelling': 'Наративний дизайн, що використовує візуальні елементи, текст і взаємодію для проведення користувачів через захопливі, емоційно резонуючі подорожі.',
  'stripe': 'Платіжна інфраструктура. Фірмові фіолетові градієнти, елегантність накреслення weight-300.',
  'supabase': 'Open-source альтернатива Firebase. Темна смарагдова тема, орієнтація на код.',
  'superhuman': 'Швидкий поштовий клієнт. Преміальний темний UI, орієнтація на клавіатуру, фіолетове сяйво.',
  'tesla': 'Електричний автопром. Радикальне віднімання, фотографії на весь viewport, майже відсутній UI.',
  'tetris': 'Дизайн у стилі класичної блокової гри з грайливими кольорами, сміливими дисплейними шрифтами та компактними, енергійними композиціями.',
  'theverge': 'Технологічне редакторське медіа. Кислотно-м\'ятні та ультрафіолетові акценти, дисплейний шрифт Manuka, сторітелінг-плитки у стилі рейв-флаєрів.',
  'together-ai': 'Інфраструктура AI з відкритим кодом. Технічний, кресленнєвий стиль дизайну.',
  'totality-festival': 'Космічно-преміальна, гласморфна темна система, що передає вісцеральний трепет перед сонячним затемненням — обсидіанові поверхні, бурштинові акценти "корони" та блакитні атмосферні акценти.',
  'trading-terminal': 'Фінансовий торговий термінал у стилі Bloomberg. Лише темний, насичений даними, блакитні/коралові сигнали купівлі/продажу. Усе читається з першого погляду з відстані двох метрів.',
  'uber': 'Платформа мобільності. Сміливий чорно-білий, щільна типографіка, міська енергія.',
  'urdu': 'Цифрові продукти з пріоритетом урду, нативною підтримкою RTL, типографікою Nastaliq та двомовною гармонією.',
  'vercel': 'Розгортання фронтенду. Чорно-біла точність, шрифт Geist.',
  'vibrant': 'Жвавий, барвистий дизайн зі сміливою грайливою типографікою, теплими акцентами та динамічною візуальною енергією.',
  'vintage': 'Ностальгія за 1950-ми — 1990-ми зі скевоморфними деталями, зернистими текстурами, ретропалітрами та піксельною типографікою.',
  'vodafone': 'Глобальний телеком-бренд. Монументальний дисплейний верхній регістр, червоні смуги розділів Vodafone Red.',
  'voltagent': 'Фреймворк AI-агентів. Полотно кольору космічної чорноти, смарагдовий акцент, рідний для терміналу.',
  'warm-editorial': 'Журнальна естетика на основі засічкових шрифтів. Теракотовий акцент на теплому майже білому папері —\nдобре підходить для довгих текстів, редакційних та брендових маркетингових сторінок.',
  'warp': 'Сучасний термінал. Темний інтерфейс у стилі IDE, блоковий командний UI.',
  'webex': 'Платформа для співпраці. Динамічна типографіка, синя система дій, багатокористувацький спектр акцентів.',
  'webflow': 'Візуальний конструктор вебсайтів. Естетика відшліфованого маркетингового сайту з синіми акцентами.',
  'wechat': 'Брендова візуальна мова для міні-програм WeChat, офіційних акаунтів та розширень відкритої екосистеми.',
  'wired': 'Технологічний журнал. Щільність газетної шпальти кольору паперово-білого, кастомний засічковий дисплейний шрифт, моноширинні підзаголовки, чорнильно-сині посилання.',
  'wise': 'Грошові перекази. Яскравий зелений акцент, дружній та зрозумілий.',
  'x-ai': 'AI-лабораторія Ілона Маска. Різкий монохром, футуристичний мінімалізм.',
  'xiaohongshu': 'Соціальна платформа лайфстайл-UGC. Єдиний фірмовий червоний, щедре заокруглення, контент на першому місці.',
  'zapier': 'Платформа автоматизації. Теплий помаранчевий, дружній, побудований на ілюстраціях.',
};

export const UK_DESIGN_SYSTEM_CATEGORIES: Record<string, string> = {
  'AI & LLM': 'AI та LLM',
  'Automotive': 'Автомобільна сфера',
  'Backend & Data': 'Бекенд і дані',
  'Bold & Expressive': 'Сміливий та виразний',
  'Creative & Artistic': 'Креативний та мистецький',
  'Design & Creative': 'Дизайн і творчість',
  'Developer Tools': 'Інструменти розробника',
  'E-Commerce & Retail': 'Електронна комерція та роздріб',
  'Editorial & Print': 'Редакційний та друкований',
  'Editorial / Personal / Publication': 'Редакційний / Особистий / Видання',
  'Editorial · Studio': 'Редакційний · Студія',
  'Fintech & Crypto': 'Фінтех і крипто',
  'Layout & Structure': 'Макет і структура',
  'Media & Consumer': 'Медіа та споживачі',
  'Modern & Minimal': 'Сучасний та мінімалістичний',
  'Morphism & Effects': 'Морфізм та ефекти',
  'Productivity & SaaS': 'Продуктивність і SaaS',
  'Professional & Corporate': 'Професійний та корпоративний',
  'Retro & Nostalgic': 'Ретро та ностальгійний',
  'Social & Messaging': 'Соцмережі та месенджери',
  'Starter': 'Початковий',
  'Themed & Unique': 'Тематичні та унікальні',
};

export const UK_PROMPT_TEMPLATE_CATEGORIES: Record<string, string> = {
  'Advertising': 'Реклама',
  'Anime': 'Аніме',
  'Anime / Manga': 'Аніме / Манґа',
  'App / Web Design': 'Дизайн застосунків / вебу',
  'Branding': 'Брендинг',
  'Cinematic': 'Кінематографічний',
  'Data': 'Дані',
  'Game UI': 'Ігровий інтерфейс',
  'General': 'Загальне',
  'Illustration': 'Ілюстрація',
  'Infographic': 'Інфографіка',
  'Live Artifact': 'Живий артефакт',
  'Marketing': 'Маркетинг',
  'Motion Graphics': 'Моушн-графіка',
  'Product': 'Продукт',
  'Profile / Avatar': 'Профіль / Аватар',
  'Short Form': 'Короткий формат',
  'Social / Meme': 'Соцмережі / Мем',
  'Social Media Post': 'Допис у соцмережах',
  'Travel': 'Подорожі',
  'VFX / Fantasy': 'VFX / Фентезі',
  'VFX / HTML-in-Canvas': 'VFX / HTML-in-Canvas',
};

export const UK_PROMPT_TEMPLATE_TAGS: Record<string, string> = {
  '3d': '3d',
  '3d-render': '3d-рендер',
  'action': 'екшн',
  'ancient-china': 'давній-китай',
  'anime': 'аніме',
  'app-showcase': 'презентація-застосунку',
  'archery': 'стрільба-з-лука',
  'arpg': 'arpg',
  'audio-reactive': 'аудіо-реактивний',
  'boss-fight': 'бій-з-босом',
  'brand': 'бренд',
  'branding': 'брендинг',
  'captions': 'субтитри',
  'cavalry': 'кавалерія',
  'chart': 'діаграма',
  'childlike': 'дитячий',
  'choreography': 'хореографія',
  'cinematic': 'кінематографічний',
  'cinematic-romance': 'кінематографічна романтика',
  'combat': 'бій',
  'combo': 'комбо',
  'companion-to-image': 'компаньйон до зображення',
  'counter': 'лічильник',
  'crayon': 'восковий олівець',
  'cyberpunk': 'кіберпанк',
  'dance': 'танець',
  'dashboard': 'дашборд',
  'data': 'дані',
  'data-viz': 'візуалізація даних',
  'destruction': 'руйнування',
  'displacement': 'зміщення',
  'editorial': 'редакційний',
  'elden-ring': 'elden-ring',
  'endcard': 'фінальна картка',
  'escort': 'супровід',
  'escort-mission': 'місія супроводу',
  'fantasy': 'фентезі',
  'fashion': 'мода',
  'fighting-game': 'файтинг',
  'food': 'їжа',
  'game-cinematic': 'ігрова кінематика',
  'game-ui': 'ігровий інтерфейс',
  'grid-sheet': 'сітка-аркуш',
  'guanyu': 'гуаньюй',
  'hand-drawn': 'намальований від руки',
  'hero': 'герой',
  'html-in-canvas': 'HTML у полотні',
  'hud': 'HUD',
  'hud-safe': 'безпечна зона HUD',
  'hype': 'хайп',
  'hyperframes': 'HyperFrames',
  'idol': 'айдол',
  'illustration': 'ілюстрація',
  'image-to-image': 'зображення до зображення',
  'infographic': 'інфографіка',
  'iphone': 'iphone',
  'japanese': 'японський',
  'karaoke': 'караоке',
  'key-visual': 'ключовий візуал',
  'keynote': 'основна доповідь',
  'kinetic-typography': 'кінетична типографіка',
  'linear-style': 'стиль Linear',
  'liquid': 'рідина',
  'liquid-glass': 'рідке скло',
  'live-artifact': 'живий артефакт',
  'logo': 'логотип',
  'lyubu': 'lyubu',
  'macbook': 'macbook',
  'magnetic': 'магнітний',
  'map': 'мапа',
  'marketing': 'маркетинг',
  'minimal': 'мінімалізм',
  'mmo': 'mmo',
  'mobile': 'мобільний',
  'money': 'гроші',
  'mounted-combat': 'кінний бій',
  'nature': 'природа',
  'open-world': 'відкритий світ',
  'otaku-dance': 'танець отаку',
  'outro': 'кінцівка',
  'overlay': 'оверлей',
  'particles': 'частинки',
  'pipeline': 'конвеєр',
  'portal': 'портал',
  'portrait': 'портрет',
  'pose-reference': 'референс пози',
  'product': 'продукт',
  'product-demo': 'демонстрація продукту',
  'product-promo': 'промо продукту',
  'rework': 'переробка',
  'route': 'маршрут',
  'saas': 'saas',
  'sequence': 'послідовність',
  'shader': 'шейдер',
  'shatter': 'розкол',
  'sizzle': 'sizzle-ролик',
  'social': 'соцмережі',
  'storyboard': 'розкадрування',
  'street-fighter': 'street-fighter',
  'style-transfer': 'перенесення стилю',
  'tekken': 'tekken',
  'text': 'текст',
  'three-kingdoms': 'три царства',
  'tiktok': 'tiktok',
  'title-card': 'титульна картка',
  'transform': 'трансформація',
  'travel': 'подорожі',
  'tts': 'tts',
  'typography': 'типографіка',
  'unreal-engine-5': 'unreal-engine-5',
  'vertical': 'вертикальний',
  'video-reference': 'відеореференс',
  'vs-screen': 'екран протистояння',
  'webgl': 'webgl',
  'website-to-video': 'сайт-у-відео',
  'wuxia': 'уся',
  'zhaoyun': 'zhaoyun',
};

export const UK_PROMPT_TEMPLATE_COPY: Record<string, Partial<Pick<PromptTemplateSummary, 'summary' | 'title'>>> = {
  '3d-stone-staircase-evolution-infographic': {
    title: '3D-інфографіка еволюції на кам\'яних сходах',
    summary:
      'Перетворює пласку хронологію еволюції на реалістичну 3D-інфографіку у вигляді кам\'яних сходів із деталізованими рендерами організмів та структурованими бічними панелями.',
  },
  'anime-martial-arts-battle-illustration': {
    title: 'Ілюстрація аніме-бою бойових мистецтв',
    summary:
      'Генерує динамічну, ефектну аніме-ілюстрацію двох жіночих персонажів, що б\'ються у традиційному додзьо зі стихійними енергетичними ефектами.',
  },
  'e-commerce-live-stream-ui-mockup': {
    title: 'UI-макет прямої трансляції для електронної комерції',
    summary:
      'Генерує реалістичний інтерфейс прямої трансляції соцмережі поверх портрета з налаштовуваними повідомленнями в чаті, спливаючими подарунками та карткою покупки товару.',
  },
  'game-screenshot-anime-fighting-game-captain-ryuuga-vs-kaze-renshin': {
    title: 'Скриншот гри — аніме-файтинг: Captain Ryuuga проти Kaze Renshin',
    summary:
      'Ключовий візуал / бойовий скриншот ігрового файтингу у стилі вступної графіки Street Fighter 6 або Tekken 8. Двоє воїнів-чоловіків в аніме-стилі сходяться у центрі драматичного нічного подвір\'я китайського храму — пірат із голим торсом і солом\'яним капелюхом із теплою помаранчево-червоною вогняною аурою ліворуч, та боєць бойових мистецтв із зачіскою-голками в помаранчевому гі, що накопичує величезну тріскучу синю кулю енергії-блискавки праворуч. Постачається з повним HUD файтингу (подвійні смуги здоров\'я, таймер раунду, портретні панелі P1/P2 з іменами бійців та емблемами, лічильники комбо та максимальні шкали для кожної сторони). Колірне розділення теплий помаранчевий проти холодного синього відповідає жанровій конвенції бійців-суперників. Налаштовано для gpt-image-2 у форматі 16:9.',
  },
  'game-screenshot-three-kingdoms-guanyu-slaying-yanliang': {
    title: 'Скриншот гри — ARPG «Три царства»: Guan Yu вбиває Yan Liang',
    summary:
      'Внутрішньоігровий скриншот action-RPG з культовою сценою «Трьох царств», де Guan Yu мчить на своєму бойовому коні Red Hare крізь поле бою під зливою і кидається на ворожого генерала Yan Liang. Відрендерено у кінематографічному фотореалістичному стилі Black Myth: Wukong, Unreal Engine 5, камера стеження від третьої особи позаду й ліворуч від вершника-героя. Повний HUD битви з босом (портрет, мінімапа з густими точками ворогів, панель навичок із підказкою фінішера, плаваюча смуга HP боса на ворожому генералі) перетворює сцену на AAA-момент бою в ARPG. Налаштовано для gpt-image-2 у форматі 16:9.',
  },
  'game-screenshot-three-kingdoms-lyubu-yuanmen-archery': {
    title: 'Скриншот гри — ARPG «Три царства»: стрільба Lü Bu біля Yuanmen',
    summary:
      'Внутрішньоігровий скриншот action-RPG зі знаменитою сценою «Трьох царств», де Lü Bu влучно збиває віддалену алебарду біля воріт табору, щоб зупинити битву. Відрендерено у кінематографічному фотореалістичному стилі Black Myth: Wukong, Unreal Engine 5 Nanite/Lumen, ігрова камера від третьої особи через плече. Повний внутрішньоігровий HUD-оверлей (смуги HP + ці, мінімапа, панель навичок, маркер захопленої цілі з показником відстані до далекої алебарди) робить зображення схожим на справжній знімок ARPG нового покоління, а не на кат-сцену. Налаштовано для gpt-image-2 у форматі 16:9.',
  },
  'game-screenshot-three-kingdoms-zhaoyun-cradle-escape': {
    title: 'Скриншот гри — ARPG «Три царства»: порятунок із немовлям Zhao Yun біля Changbanpo',
    summary:
      'Внутрішньоігровий скриншот action-RPG із легендарною сценою «Трьох царств», де Zhao Yun тримає немовля Liu Chan на одній руці й пробивається крізь ворожі лави зі списом в іншій біля Changbanpo. Відрендерено у кінематографічному фотореалістичному стилі Black Myth: Wukong у поєднанні з Elden Ring, Unreal Engine 5 із повним Nanite, трасуванням променів Lumen та об\'ємними променями світла. Емоційне ядро — одна рука захищає сповите немовля, інша б\'ється за життя — підкреслене повним HUD-оверлеєм, що включає окрему смугу захисту ESCORT для немовляти, лічильник комбо та спливаючі цифри ушкоджень у повітрі на відкинутих ворогах. Налаштовано для gpt-image-2 у форматі 16:9.',
  },
  'game-ui-ancient-china-open-world-mmo-hud': {
    title: 'Ігровий UI — HUD MMO з відкритим світом стародавнього Китаю',
    summary:
      'Генерує макет скриншота внутрішньоігрового HUD для AAA MMO з відкритим світом стародавнього Китаю у кінематографічному фотореалістичному стилі Black Myth: Wukong. Прекрасна головна героїня-фехтувальниця закріплює центр кадру в туманній гірській сцені стародавнього святилища, оточена повним HUD MMO: портрет персонажа у верхньому лівому куті зі смугами HP/MP/витривалості та іконками баффів, панель навичок у нижньому центрі з іконками навичок у стилі китайської каліграфії, мінімапа у верхньому правому куті з маркерами квестів, панель відстеження квестів праворуч, прокручуване вікно чату в нижньому лівому куті, плаваючі таблички імен NPC у просторі світу та знак оклику квесту. Відрендерено як реалістичний скриншот монітора, 16:9, придатний для пітч-деків, ключової графіки у стилі gamescom та ігрових тизерів для Xiaohongshu/bilibili.',
  },
  'illustrated-city-food-map': {
    title: 'Ілюстрована гастрономічна карта міста',
    summary:
      'Генерує намальовану від руки туристичну карту в акварельному стилі з пронумерованими місцевими гастрономічними спеціальностями, визначними пам\'ятками та легендою.',
  },
  'illustration-crayon-kid-drawing-rework': {
    title: 'Ілюстрація — переробка дитячого малюнка олівцями',
    summary:
      'Промпт для перенесення стилю, який перетворює будь-яке еталонне зображення (фото товару, скриншот, портрет, макет UI) на намальовану від руки ілюстрацію восковими олівцями, що виглядає так, ніби її зробила 10-річна дитина. Замінює оригінальну палітру яскравими грайливими кольорами воскових олівців на чистому білому папері та додає дитячу примхливість — замки, цукерки, зірки, хмари, веселки, — щоб підсилити невинну атмосферу казкової книжки. Працює як редагування зображення в зображення в GPT-image-2 (потребує завантаження еталонного зображення разом із промптом); добре підходить для скриншотів вебсайтів, ключових візуалів бренду, фотографій товарів і портретів.',
  },
  'infographic-otaku-dance-choreography-breakdown-gokurakujodo-16-panels': {
    title: 'Інфографіка — розбір отаку-хореографії танцю (Gokuraku Jodo, 16 панелей)',
    summary:
      'Один вертикальний постер 2:3, скомпонований як сітка 4×4 із 16 з\'єднаних квадратних панелей, що утворюють повну схему розбору хореографії знаменитої японської отаку-танцювальної пісні 極楽浄土 (Gokuraku Jodo). Кожна панель показує одну й ту саму милу напівреалістичну дівчину-аніме айдола (рожеві двійні хвостики, форма школярки-айдола з матроським коміром), яка виконує одну фірмову позу з танцю, на повний зріст, на пастельно-рожевому фоні з невеликою стрічкою японського підпису внизу та пронумерованим колом у верхньому лівому куті. Спеціально розроблено як аркуш-РЕФЕРЕНС ПОЗ для генерації відео ШІ — кожен силует чіткий і однозначний, без ліній руху чи фонового безладу. Налаштовано для gpt-image-2, співвідношення 2:3. Категорія: Інфографіка.',
  },
  'momotaro-explainer-slide-in-hybrid-style': {
    title: 'Пояснювальний слайд про Момотаро в гібридному стилі',
    summary:
      'Промпт, який поєднує просту, теплу естетику ілюстрацій Irasutoya з високою інформаційною щільністю, характерною для слайдів японського уряду.',
  },
  'notion-team-dashboard-live-artifact': {
    title: 'Командна панель у стилі Notion (живий артефакт)',
    summary:
      'Макет командної панелі в нативному стилі Notion на один екран — сітка KPI, спарклайн за 7 днів, стрічка активності та таблиця завдань зі зв\'язаною базою даних. Візуальний компаньйон до навички живого артефакту; поєднуйте з нею для оновлюваних запусків із підтримкою конекторів або використовуйте окремо як статичний макет.',
  },
  'profile-avatar-anime-girl-to-cinematic-photo': {
    title: 'Профіль / Аватар — дівчина-аніме на кінематографічне фото',
    summary:
      'Цей промпт перетворює еталонну ілюстрацію персонажа на реалістичний, тепло-тонований вінтажний інтер\'єрний портрет, зберігаючи оригінальний одяг, позу та кота.',
  },
  'profile-avatar-casual-fashion-grid-photoshoot': {
    title: 'Профіль / Аватар — фотосесія повсякденної моди у вигляді сітки',
    summary:
      'Структурований JSON-промпт для колажу з 4 фото повсякденної модної фотосесії з детальними параметрами об\'єкта та освітлення.',
  },
  'profile-avatar-cinematic-south-asian-male-portrait-with-vultures': {
    title: 'Профіль / Аватар — кінематографічний портрет південноазійського чоловіка зі стерв\'ятниками',
    summary:
      'Детальний кінематографічний портрет молодого південноазійського чоловіка в похмурому, темному фентезійному оточенні в оточенні стерв\'ятників і круків.',
  },
  'profile-avatar-cyberpunk-anime-portrait-with-neon-face-text': {
    title: 'Профіль / Аватар — кіберпанк аніме-портрет із неоновим текстом на обличчі',
    summary:
      'Стильний насичений неоном аніме-портрет для постерів, контенту в соцмережах або футуристичних візуалів бренду.',
  },
  'profile-avatar-elegant-fantasy-girl-in-violet-garden': {
    title: 'Профіль / Аватар — елегантна фентезійна дівчина у фіолетовому саду',
    summary:
      'Цей промпт генерує відшліфований фентезійний портрет у стилі аніме елегантної жінки з блискучим укладеним волоссям, вишуканим фіолетово-чорним вбранням і чарівним садом, повним квітів, ідеально підходить для персонажа',
  },
  'profile-avatar-ethereal-blue-haired-fantasy-portrait': {
    title: 'Профіль / Аватар — ефірний фентезійний портрет із синім волоссям',
    summary:
      'Цей промпт генерує м\'який, осяйний фентезійний портрет персонажа в стилі аніме, ідеально підходить для створення елегантного вертикального ключового візуалу або ілюстрацій персонажів зі струмливим волоссям і мрійливою весняною атмосферою.',
  },
  'profile-avatar-glamorous-woman-in-black-portrait': {
    title: 'Профіль / Аватар — гламурна жінка в чорному портреті',
    summary:
      'Цей промпт генерує фотореалістичний портрет у розкішному стилі елегантної жінки в чорному вбранні з глибоким вирізом, ідеально підходить для модної редакторської зйомки чи б\'юті-візуалів.',
  },
  'profile-avatar-hyper-realistic-selfie-texture-prompts': {
    title: 'Профіль / Аватар — промпти для гіперреалістичної текстури селфі',
    summary:
      'Детальні фрагменти промптів для генерації реалістичних текстур шкіри та автентичного кадрування селфі на телефон, з акцентом на видимі пори та природне освітлення.',
  },
  'profile-avatar-lavender-fantasy-mage-portrait': {
    title: 'Профіль / Аватар — лавандовий фентезійний портрет мага',
    summary:
      'Цей промпт генерує відшліфований фентезійний портрет у стилі аніме елегантної принцеси-мага з блискучим білявим волоссям, фіолетовими квітами та вишуканим кришталевим вбранням, ідеально підходить для арту персонажа чи чарівних ілюстрацій',
  },
  'profile-avatar-monochrome-studio-portrait': {
    title: 'Профіль / Аватар — монохромний студійний портрет',
    summary:
      'Промпт для висококласної комерційної фотографії монохромного портрета з характерним розділеним фоном і драматичним студійним освітленням.',
  },
  'profile-avatar-old-photo-restoration-to-dslr-portrait': {
    title: 'Профіль / Аватар — реставрація старого фото в портрет із дзеркальної камери',
    summary:
      'Цей промпт відновлює пошкоджене вінтажне сімейне фото з 4 осіб у чистий, колоризований, реалістичний портрет високої роздільної здатності для ремонту та покращення фотографій.',
  },
  'profile-avatar-poetic-woman-in-garden-portrait': {
    title: 'Профіль / Аватар — поетична жінка в портреті в саду',
    summary:
      'Цей промпт генерує реалістичний портрет у редакторському стилі начитаної молодої жінки в залитому сонцем саду, ідеально підходить для лайфстайл-фотографії, літературного брендингу чи елегантних візуалів персонажів.',
  },
  'profile-avatar-professional-identity-portrait-wallpaper': {
    title: 'Профіль / Аватар — професійні шпалери з портретом особистості',
    summary:
      'Генерує преміальні шпалери високої роздільної здатності із зображенням об\'єкта в професійному вбранні з пов\'язаними з кар\'єрою активностями та типографікою.',
  },
  'profile-avatar-realistically-imperfect-ai-selfie': {
    title: 'Профіль / Аватар — реалістично недосконале селфі від ШІ',
    summary:
      'Креативний промпт, який використовується з GPT Image 2 для генерації «невдалого» селфі, що виглядає як випадковий, низькоякісний знімок зі смартфона.',
  },
  'profile-avatar-signed-marker-portrait-on-shikishi': {
    title: 'Профіль / Аватар — підписаний портрет маркером на shikishi',
    summary:
      'Це генерує живий підписаний портрет у стилі маркера на квадратній дошці shikishi, корисний для автографів фан-арту, пам\'ятних ілюстраційних постів і персоналізованих візуалів подяки.',
  },
  'profile-avatar-snow-rabbit-empress-portrait': {
    title: 'Профіль / Аватар — портрет імператриці снігового кролика',
    summary:
      'Промпт для реалістичного фентезійного портрета для генерації величної жінки в кролячій тематиці у вишуканому зимовому ханьфу, що стоїть у засніженому гірському храмі.',
  },
  'profile-avatar-snow-rabbit-mask-hanfu-portrait': {
    title: 'Профіль / Аватар — портрет у ханьфу з маскою снігового кролика',
    summary:
      'Цей промпт генерує кінематографічний зимовий фентезійний портрет жінки в масці у білому ханьфу в кролячому стилі, ідеальний для елегантного персонажного арту та атмосферних демонстраційних AI-зображень.',
  },
  'profile-avatar-snowy-rabbit-hanfu-portrait': {
    title: 'Профіль / Аватар — Портрет у сніжному кролячому ханьфу',
    summary:
      'Цей промпт генерує надзвичайно деталізований фентезійний портрет красуні з кролячими вухами у вишитому ханьфу, ідеальний для елегантного персонажного арту, дизайну костюмів або кінематографічних демонстрацій AI-портретів.',
  },
  'profile-avatar-snowy-rabbit-spirit-portrait': {
    title: 'Профіль / Аватар — Портрет духу сніжного кролика',
    summary:
      'Цей промпт генерує безтурботний фентезійний портрет анонімної жінки з кролячими вухами взимку, ідеальний для атмосферного персонажного арту та стилізованих ілюстрацій профілю.',
  },
  'profile-avatar-song-dynasty-hanfu-portrait': {
    title: 'Профіль / Аватар — Портрет у ханьфу династії Сун',
    summary:
      'Оптимізований промпт для генерування деталізованого та реалістичного портрета красуні у традиційному ханьфу династії Сун у стародавньому подвір\'ї.',
  },
  'social-media-post-anime-pokemon-shop-outfit-teaser-poster': {
    title: 'Допис у соцмережах — Тизерний постер аніме-вбрання з магазину Pokémon',
    summary:
      'Цей промпт генерує м\'який пастельний аніме-постер з анонсом моди, на якому зображена дівчина з розмитим обличчям у синій сукні всередині магазину Pokémon, ідеальний для тизерів презентації вбрання та промо-візуалів персонажів.',
  },
  'social-media-post-cinematic-elevator-scene': {
    title: 'Допис у соцмережах — Кінематографічна сцена у ліфті',
    summary:
      'Промпт для генерування атмосферної кінематографічної сцени з жінкою всередині металевого ліфта з реалістичним освітленням та відбиттями.',
  },
  'social-media-post-confused-elf-girl-at-pastel-desk': {
    title: 'Допис у соцмережах — Розгублена дівчина-ельф за пастельним столом',
    summary:
      'Цей промпт генерує м\'яку пастельну аніме-ілюстрацію дівчини-ельфа, яка друкує за комп\'ютером у затишному кавай-робочому просторі, ідеальну для дописів у соцмережах, шпалер або арту в стилі стримерів.',
  },
  'social-media-post-editorial-fashion-photography': {
    title: 'Допис у соцмережах — Редакційна модна фотографія',
    summary:
      'Атмосферний промпт із фокусом на моді для мінімалістичної студійної сцени з м\'яким освітленням та теплими тонами.',
  },
  'social-media-post-fashion-editorial-collage': {
    title: 'Допис у соцмережах — Колаж модної редакційної зйомки',
    summary:
      'Високодеталізований промпт для фотоколажу 2x2 для модних редакційних знімків із фокусом на узгодженому стилі, специфічному освітленні та рисах обличчя з референсного фото.',
  },
  'social-media-post-psg-transfer-announcement-poster': {
    title: 'Допис у соцмережах — Постер з анонсом трансферу PSG',
    summary:
      'Сміливий професійний футбольний постер про підписання гравця для оголошення переходу до Paris Saint-Germain у соцмережах або спортивній промо-графіці.',
  },
  'social-media-post-sensational-girl-dance-storyboard-8-shots': {
    title: 'Допис у соцмережах — Розкадровка ефектного дівочого танцю (8 кадрів)',
    summary:
      'Повний набір промптів розкадровки на 8 кадрів для генерування цілісної покадрової танцювальної послідовності стильного персонажа. Включає спільні глобальні токени стилю, багаторазовий негативний промпт та вісім промптів для кожного кадру (початкова поза, рух стегнами, хвиля тілом, поворот талії на біт-дропі, бічне погойдування стегон, помах волоссям, силова стійка, фінальна поза). Налаштований для моделей рівня GPT-Image-2: лаконічна лексика, без чутливих формулювань, узгоджена мова кадрування та освітлення між кадрами, щоб кадри сприймалися як одна безперервна хореографія.',
  },
  'social-media-post-showa-day-retro-culture-magazine-cover': {
    title: 'Допис у соцмережах — Ретро культурна обкладинка журналу до Дня Сьова',
    summary:
      'Тепла сторінка-фіча в редакційному стилі до японського свята, що поєднує аніме-арт персонажів, ностальгічні вуличні образи епохи Сьова та інформаційну верстку в журнальному стилі для сезонних культурних промоакцій.',
  },
  'social-media-post-social-media-fashion-outfit-generation': {
    title: 'Допис у соцмережах — Генерування модного вбрання для соцмереж',
    summary:
      'Промпт для генерування тижневого набору рекомендацій вбрання в стилі модного блогера на основі профілю персонажа, з підписами та цінами на речі.',
  },
  'social-media-post-travel-snapshot-collage-prompt': {
    title: 'Допис у соцмережах — Промпт для колажу подорожніх знімків',
    summary:
      'Деталізований промпт для створення ностальгічного колажу з 12 кадрів подорожніх фото в стилі смартфона, що зображує самостійну подорож.',
  },
  'social-media-post-vintage-sign-painter-sketch': {
    title: 'Допис у соцмережах — Вінтажний ескіз майстра-вивісок',
    summary:
      'Генерує намальований від руки ескіз маркером на папері з реалістичними деталями, як-от графітні лінії та розтікання чорнила, ідеальний для вінтажних стилів написів.',
  },
  'vr-headset-exploded-view-poster': {
    title: 'Постер з рознесеним виглядом VR-гарнітури',
    summary:
      'Генерує високотехнологічну діаграму рознесеного вигляду VR-гарнітури з детальними виносками компонентів та промо-текстом.',
  },
  '3d-animated-boy-building-lego': {
    title: '3D-анімований хлопчик складає Lego',
    summary:
      'Багатокадровий відеопромпт у стилі 3D-анімації, що описує хлопчика, який обережно складає деталі Lego в кімнаті, з ефектами таймлапсу.',
  },
  'a-decade-of-refinement-glow-up': {
    title: 'Десятиліття вдосконалення Glow-Up',
    summary:
      'Промпт трансформації для Seedance 2.0, що показує перехід чоловіка від повсякденного оточення 2016 року до розкішного дубайського способу життя 2026 року зі збереженням послідовності персонажа.',
  },
  'ancient-guardian-dragon-rescue': {
    title: 'Порятунок стародавнім драконом-охоронцем',
    summary:
      'Деталізований багатокадровий кінематографічний промпт для історії про дівчину в дощовому селі, яку рятує дракон, що з\'являється, з фокусом на VFX та атмосферному звуці.',
  },
  'ancient-indian-kingdom-fpv-video': {
    title: 'FPV-відео стародавнього індійського королівства',
    summary:
      'Динамічний кінематографічний промпт у стилі FPV-дрона, що зображує містичне індійське королівство з храмами та джунглями.',
  },
  'animation-transfer-and-camera-tracking-prompt': {
    title: 'Промпт перенесення анімації та відстеження камери',
    summary:
      'Технічний промпт для Seedance 2.0, який застосовує конкретний референс руху до персонажа, зберігаючи фіксоване стеження камери.',
  },
  'beat-synced-outfit-transformation-dance': {
    title: 'Танець із трансформацією вбрання в ритм біту',
    summary:
      'Промпт для Seedance 2.0, який узгоджує танець персонажа за кадрами розкадрування з одночасною зміною вбрання в ритм біту.',
  },
  'character-intro-motion-graphics-sequence': {
    title: 'Послідовність моушн-графіки для представлення персонажа',
    summary:
      'Складний багатоетапний промпт моушн-графіки для представлення команди персонажів із конкретними UI-накладками та переходами, розроблений для моделі Seedance 2.0.',
  },
  'cinematic-birthday-celebration-sequence': {
    title: 'Кінематографічна послідовність святкування дня народження',
    summary:
      'Надзвичайно детальний багатокадровий відеопромпт для послідовності дня народження з акцентом на узгодженості персонажів та емоційному сторітелінгу.',
  },
  'cinematic-dragon-interaction-flight': {
    title: 'Кінематографічна взаємодія з драконом і політ',
    summary:
      'Детальний промпт у стилі розкадрування для відео, що показує емоційну взаємодію жінки з драконом, після якої йде кінематографічна послідовність польоту.',
  },
  'cinematic-east-asian-woman-hand-dance': {
    title: 'Кінематографічний танець рук східноазійської жінки',
    summary:
      'Надзвичайно детальний багатокадровий кінематографічний відеопромпт для стилізованого танцю рук із таймкодованими інструкціями для рухів камери та дій персонажа.',
  },
  'cinematic-emotional-face-close-up': {
    title: 'Кінематографічний емоційний крупний план обличчя',
    summary:
      'Надзвичайно детальний технічний промпт для Seedance 2.0 з акцентом на реалістичних текстурах шкіри та серії складних емоційних переходів виразу обличчя.',
  },
  'cinematic-marine-biologist-exploration': {
    title: 'Кінематографічне дослідження морського біолога',
    summary:
      'Детальний кінематографічний відеопромпт для підводної сцени, де морський біолог виявляє стародавню затонулу корабель серед коралового рифу.',
  },
  'cinematic-music-podcast-and-guitar-technique': {
    title: 'Кінематографічний музичний подкаст і гітарна техніка',
    summary:
      'Просунутий кінематографічний промпт для генерації 4K-відео музичного подкасту з особливим акцентом на гітарній техніці, pinch harmonics та студійній естетиці.',
  },
  'cinematic-route-navigation-guide': {
    title: 'Кінематографічний путівник навігації маршрутом',
    summary:
      'Структурований багатосценовий промпт, розроблений для Seedance, щоб створити узгоджене навігаційне відео пішої прогулянки з повторюваним персонажем-гідом та плавними переходами між реальними локаціями.',
  },
  'cinematic-street-racing-sequence-for-seedance-2': {
    title: 'Кінематографічна послідовність вуличних перегонів для Seedance 2',
    summary:
      'Детальний багатокадровий промпт, розроблений для Seedance 2, щоб згенерувати кінематографічну послідовність нічних вуличних перегонів з акцентом на напруженій зосередженості водія, динамічній роботі камери та вибуховому прискоренні, структ',
  },
  'cinematic-vampire-alley-fight-sequence': {
    title: 'Кінематографічна послідовність бійки з вампіром у провулку',
    summary:
      'Вичерпний екшн-промпт для сцени короткометражного фільму з динамічними рухами камери та швидкісним боєм у залитому неоном провулку.',
  },
  'crimson-horizon-sci-fi-cinematic-sequence': {
    title: 'Кінематографічна науково-фантастична послідовність Crimson Horizon',
    summary:
      'Вичерпна кінематографічна відеопослідовність із 9 кадрів для науково-фантастичного фільму під назвою «Crimson Horizon», що детально описує все — від запуску ракети до моторошної зустрічі з прибульцями на Марсі.',
  },
  'cyberpunk-game-trailer-script': {
    title: 'Сценарій трейлера кіберпанк-гри',
    summary:
      'Розгорнутий промпт генерації відео для трейлера кіберпанк-гри, що детально описує дизайн персонажа, UI-анімації та переходи середовища від білої порожнечі до фавели.',
  },
  'forbidden-city-cat-satire': {
    title: 'Сатира про кота в Забороненому місті',
    summary:
      'Складний промпт у жанрі чорної комедії для Seedance 2.0 із рудим котом-чиновником та імператором-гієною в сатиричному антуражі династії Цін.',
  },
  'hollywood-haute-couture-fantasy-video-prompt': {
    title: 'Голлівудський відеопромпт фентезі від-кутюр',
    summary:
      'Детальний багатосценовий промпт генерації відео для Seedance 2.0, розроблений для створення голлівудського фентезі-фільму від-кутюр. Промпт визначає стиль, роздільну здатність (8K), рушій рендерингу (Unreal Engin',
  },
  'hunched-character-animation': {
    title: 'Анімація згорбленого персонажа',
    summary:
      'Інструкція для Seedance 2 створити анімацію ходьби на місці для конкретного референсу персонажа.',
  },
  'hyperframes-html-in-canvas-iphone-device': {
    title: 'HyperFrames HTML-in-Canvas: 3D-демо продуктів iPhone + MacBook',
    summary:
      '15-секундна демонстрація продукту, де реальні GLTF-моделі iPhone 15 Pro Max і MacBook Pro ширяють на чистій сцені, а на їхніх екранах у реальному часі рендериться справжній UI застосунку через drawElementImage. Морфінговий відблиск скляної лінзи + поворотний стіл на 360°. Створено на основі блоку каталогу vfx-iphone-device.',
  },
  'hyperframes-html-in-canvas-text-cursor': {
    title: 'HyperFrames HTML-in-Canvas: Кінематографічне розкриття тексту курсором',
    summary:
      '8-секундне драматичне розкриття тексту зі світінням курсора, хроматичними тіньовими променями та напрямленим освітленням на чорній сцені. Справжня DOM-типографіка під живою шейдерною постобробкою. Створено на основі блоку каталогу vfx-text-cursor.',
  },
  'hyperframes-html-in-canvas-shatter': {
    title: 'HyperFrames HTML-in-Canvas: Завершальна заставка з розбиттям скла',
    summary:
      '12-секундна HTML-завершальна заставка з розбиттям — справжня сторінка продукту чи картка цін завмирає на мить, а потім вибухає на заломлюючі скляні фрагменти з розмиттям глибини та хроматичною дисперсією. Створено на основі блоку каталогу vfx-shatter. Поєднується як завершальна картка після довшої композиції.',
  },
  'hyperframes-html-in-canvas-liquid-background': {
    title: 'HyperFrames HTML-in-Canvas: Герой-секція з рідким фоном',
    summary:
      '12-секундний hero-ролик з HTML-вмістом, що ширяє над органічною рідкою поверхнею — субдивізована площина зі зміщенням вершин, хвильова динаміка в реальному часі, захоплений DOM розташований зверху чітко й читабельно. Побудовано на блоці каталогу vfx-liquid-background.',
  },
  'hyperframes-html-in-canvas-liquid-glass': {
    title: 'HyperFrames HTML-in-Canvas: розкриття лендингу Liquid Glass',
    summary:
      '20-секундне розкриття реального лендингу продукту у стилі voronoi liquid-glass — DOM захоплюється наживо через drawElementImage, розбивається на заломлюючі скляні комірки, а потім осідає у чистий hero-кадр. Побудовано на блоці каталогу vfx-liquid-glass.',
  },
  'hyperframes-html-in-canvas-magnetic': {
    title: 'HyperFrames HTML-in-Canvas: візуалізація магнітного поля',
    summary:
      '15-секундна візуалізація частинок магнітного поля, що реагує на живу DOM-теплокарту або діаграму — частинки окреслюють силові лінії, що згинаються навколо захопленого HTML, ідеально для ML/дата-продуктів. Побудовано на блоці каталогу vfx-magnetic.',
  },
  'hyperframes-html-in-canvas-portal-reveal': {
    title: 'HyperFrames HTML-in-Canvas: дашборд із розкриттям-порталом',
    summary:
      '10-секундний вимірний портал відкривається на живий дата-дашборд — DOM захоплено в реальному часі, об\'ємне розливання світла, частинки по краю порталу. Побудовано на блоці каталогу vfx-portal. Розроблено для hero-кадрів даних у стилі keynote.',
  },
  'hyperframes-money-counter-hype': {
    title: 'HyperFrames: лічильник грошей $0 → $10K у стилі hype (9:16)',
    summary:
      '6-секундний вертикальний 1080×1920 hype-кліп HyperFrames — лічильник $0 → $10 000 у стилі Apple із зеленим спалахом, частинками грошового вибуху, іконкою стопки готівки, заголовком-кікером. Побудовано на блоці каталогу HyperFrames `apple-money-count`.',
  },
  'hyperframes-app-showcase-three-phones': {
    title: 'HyperFrames: 12-секундна презентація застосунку — три ширяючі телефони',
    summary:
      '12-секундна композиція-презентація застосунку 16:9 — три ширяючі екрани iPhone зависають у 3D-просторі, кожен по черзі обертається, щоб показати іншу функцію, синхронізовані з бітом підписи-виноски, фінальне зведення логотипа. Побудовано безпосередньо на блоці каталогу HyperFrames `app-showcase`.',
  },
  'hyperframes-brand-sizzle-reel': {
    title: 'HyperFrames: 30-секундний бренд-сіззл рілз',
    summary:
      '30-секундний сіззл-рілз HyperFrames 16:9 — швидкі склейки, синхронізована з бітом кінетична типографіка, аудіореактивне масштабування на дисплейних словах, шейдерні переходи між п\'ятьма сценами, фінальна картка з розквітом логотипа. Змодельовано за архетипом aisoc-hype зі студентського набору.',
  },
  'hyperframes-saas-product-promo-30s': {
    title: 'HyperFrames: 30-секундне промо SaaS-продукту (у стилі Linear)',
    summary:
      '30-секундна композиція HyperFrames, змодельована за продуктовими фільмами у стилі Linear/ClickUp — 3D-розкриття UI, синхронізована з бітом кінетична типографіка, анімовані скриншоти UI, фінальна картка з аутро-логотипом. Побудовано з блоків каталогу HF (ui-3d-reveal, app-showcase, logo-outro) плюс шейдерні переходи між сценами.',
  },
  'hyperframes-logo-outro-cinematic': {
    title: 'HyperFrames: 4-секундне кінематографічне аутро з логотипом',
    summary:
      '4-секундне аутро з логотипом 16:9 — поступова покрокова збірка вордмарка з розквітом, мерехтливий змах по фінальному зведенню, м\'яке зернисте накладання, однорядковий CTA. Побудовано на блоках HyperFrames `logo-outro`, `shimmer-sweep` та `grain-overlay`.',
  },
  'hyperframes-product-reveal-minimal': {
    title: 'HyperFrames: 5-секундне мінімалістичне розкриття продукту',
    summary:
      '5-секундна композиція HyperFrames для преміального розкриття продукту — темне полотно, єдиний теплий акцент, повільне наближення титрової картки, кінетичний рядок-кікер, стриманий рух. Агент рендерить MP4 з HTML+GSAP через puppeteer; стокові кадри не потрібні.',
  },
  'hyperframes-social-overlay-stack': {
    title: 'HyperFrames: вертикальний стек соціальних оверлеїв 9:16 (X · Reddit · Spotify · Instagram)',
    summary:
      '15-секундна вертикальна композиція HyperFrames 1080×1920, яка стекає чотири анімовані соціальні картки поверх face-cam циклу — пост в X, реакція в Reddit, картка "зараз грає" Spotify та CTA-підписка в Instagram наприкінці. Кожна картка — це блок каталогу HyperFrames; хореографія — додана цінність.',
  },
  'hyperframes-tiktok-karaoke-talking-head': {
    title: 'HyperFrames: 9:16 TikTok talking-head з караоке-субтитрами',
    summary:
      'Вертикальний шортс HyperFrames 1080×1920 — talking-head з TTS-озвучкою поверх face-cam циклу, з караоке-субтитрами, синхронізованими по словах, анімованим нижнім третім та оверлеєм tiktok-підписки наприкінці. Віддзеркалює архетип may-shorts-19 зі студентського набору HyperFrames.',
  },
  'hyperframes-data-bar-chart-race': {
    title: 'HyperFrames: анімовані перегони стовпчикової діаграми (у стилі NYT)',
    summary:
      '12-секундна дата-інфографіка 16:9 — анімована стовпчикова + лінійна діаграма зі ступінчастим розкриттям категорій, заголовок із серифом у стилі NYT, виноска з джерелом, кінетичні підписи значень. Побудовано безпосередньо на блоці каталогу HyperFrames `data-chart`.',
  },
  'hyperframes-flight-map-route': {
    title: 'HyperFrames: карта рейсу у стилі Apple (відправлення → призначення)',
    summary:
      '8-секундна кінематографічна карта маршруту рейсу 16:9 — реалістичне наближення рельєфу, анімований літак, що ковзає від відправлення до призначення вздовж вигнутого шляху, підписані міста, кінетичний лічильник відстані. Побудовано безпосередньо на блоці каталогу HyperFrames `nyc-paris-flight`, придатне для будь-якої пари міст.',
  },
  'hyperframes-website-to-video-promo': {
    title: 'HyperFrames: конвеєр Website-to-Video (15-секундна маркетингова нарізка)',
    summary:
      '15-секундна композиція HyperFrames 16:9, яка захоплює живий вебсайт у трьох розмірах вьюпорта, а потім анімує між ними з хроматичним радіальним розколом між сценами. Віддзеркалює архетип hyperframes-sizzle зі студентського набору, де сайт є вихідним ресурсом.',
  },
  'live-action-anime-adaptation-water-vs-thunder-breathing-duel': {
    title: 'Лайв-екшн адаптація аніме: дуель Дихання Води проти Дихання Грому',
    summary:
      'Надзвичайно детальний 15-секундний промпт для генерації лайв-екшн адаптації дуелі в стилі аніме, що показує \'Дихання Води\' (синій водяний дракон) проти \'Дихання Грому\' (золота блискавка). P',
  },
  'luxury-supercar-cinematic-narrative': {
    title: 'Кінематографічний наратив про розкішний суперкар',
    summary:
      'Надзвичайно детальний багатокадровий кінематографічний промпт для Seedance 2.0 за участю стильного чоловіка, доберманів та вінтажного суперкара в туманному гірському оточенні.',
  },
  'magical-academy-storyboard-sequence': {
    title: 'Послідовність розкадровки магічної академії',
    summary:
      'Детальний промпт у стилі розкадровки для кінематографічної послідовності, що зображує дівчину-магиню в академії, охоплюючи прибуття, відкриття сили та магічну дуель.',
  },
  'modern-rural-aesthetics-healing-short-film-video-prompt': {
    title: 'Промпт для відео цілющого короткометражного фільму в естетиці сучасного сільського стилю',
    summary:
      'Детальний трикадровий промпт для Seedance 2.0 для генерації цілющого кінематографічного короткометражного фільму в естетиці сучасного сільського стилю. Він задає стиль (Cinematic Commercial, 4K/8K, екстремальне макро, nat',
  },
  'nightclub-flyer-atmospheric-animation': {
    title: 'Атмосферна анімація флаєра нічного клубу',
    summary:
      'Тонкий анімаційний промпт для Seedance 2.0, щоб оживити фонові та світлові елементи, тримаючи об\'єкт зафіксованим',
  },
  'retro-hk-wuxia-film-aesthetic': {
    title: 'Естетика ретро гонконгського фільму уся',
    summary:
      'Складний багатоскладовий відеопромпт, що відтворює естетику гонконгських фільмів жанру уся 80-90-х років, із трансформацією персонажа з кота на людину у стилізованих кадрах.',
  },
  'seedance-2-0-15-second-cinematic-japanese-romance-short-film': {
    title: 'Seedance 2.0: 15-секундна кінематографічна японська романтична короткометражка',
    summary:
      'Дуже детальний 15-секундний багатосценовий промпт для Seedance 2.0, створений для генерації кінематографічної, ультрареалістичної японської короткометражки про чисте кохання в старшій школі. Промпт визначає декорації сцени (порожній',
  },
  'seedance-2-0-80-year-old-rapper-mv': {
    title: 'Seedance 2.0: Музичне відео 80-річного репера',
    summary:
      'Детальний 15-секундний промпт для Seedance 2.0 для генерації горизонтального музичного відео (MV) у форматі 16:9 з вуличним репом за участю 80-річної жінки. Промпт визначає стиль (неонові фіолетово-блакитні холодні тони, exp',
  },
  'sequence-and-movement-instruction-for-martial-arts-video': {
    title: 'Інструкція з послідовності та рухів для відео про бойові мистецтва',
    summary:
      'Відеопромпт для Seedance 2.0, що вказує моделі анімувати послідовність на основі аркуша персонажа, зосереджуючись на конкретних рухах і кроках.',
  },
  'soul-switching-mirror-magic-sequence': {
    title: 'Магічна послідовність обміну душами біля дзеркала',
    summary:
      'Наративний відеопромпт, що описує магічну подію обміну душами біля дзеркала, з конкретними інструкціями щодо камери та емоційними підказками для кожного сегмента.',
  },
  'toaster-rocket-jumpscare': {
    title: 'Лякалка з тостером-ракетою',
    summary:
      'Промпт для реалістичного кадру в стилі домашнього відео, де літнього чоловіка лякає тостер, що запускає хліб, наче ракету.',
  },
  'traditional-dance-performance': {
    title: 'Виступ із традиційним танцем',
    summary:
      'Вичерпний відеопромпт для Seedance 2.0 для генерації граційного традиційного танцю на основі хореографії та референсних зображень особистості.',
  },
  'video-seedance-three-kingdoms-guanyu-slaying-yanliang': {
    title: 'Відео — Three Kingdoms ARPG — Гуань Юй вбиває Янь Ляна (Seedance 2.0)',
    summary:
      'Кінематографічна екшн-послідовність тривалістю ~10 с, відтворена в рушії, яка оживляє супутній шаблон зображення game-screenshot-three-kingdoms-guanyu-slaying-yanliang. Гуань Юй (关羽) мчить на своєму коні Червоному Зайцеві прямо в бойову лінію ворога, здіймає Алебарду Зеленого Дракона й одним чистим ударом розсікає ворожого полководця Янь Ляна. Налаштовано під Seedance 2.0 — суворий контроль камери, один рішучий удар, чиста фізика коня й клинка, фотореалістичне освітлення, абсолютно жодної крові на екрані (удар позначений золотим спалахом ці, а не кров\'ю). Розроблено як прямий відеосупутник до відповідного шаблону зображення, щоб стоп-кадр і кліп можна було подавати в парі. Референсне зображення: шаблон скриншоту з Гуань Юєм, який вбиває Янь Ляна.',
  },
  'video-seedance-three-kingdoms-lyubu-yuanmen-archery': {
    title: 'Відео — Three Kingdoms ARPG — Стрільба Люй Бу біля воріт табору (Seedance 2.0)',
    summary:
      'Кінематографічна екшн-послідовність тривалістю ~10 с, відтворена в рушії, яка оживляє супутній шаблон зображення game-screenshot-three-kingdoms-lyubu-yuanmen-archery. Люй Бу (吕布) стоїть у центрі курного військового табору між двома арміями, що стоять одна навпроти одної, натягує лук із червоним лакуванням, утримує намистину на натязі, а потім випускає одну золотосяйну стрілу, насичену ці, уздовж стрільбища до далекої алебарди, встромленої в землю. Налаштовано під Seedance 2.0 — суворий контроль камери, один рішучий момент, чітке кадрування, безпечне для HUD, чиста фізика лука й стріли, рух вітру, пилу й прапорів та кольорокорекція в стилі ігрового скриншоту. Розроблено як прямий відеосупутник до відповідного шаблону зображення, щоб стоп-кадр і кліп можна було подавати в парі. Референсне зображення: шаблон скриншоту зі стрільбою Люй Бу біля воріт табору.',
  },
  'video-seedance-three-kingdoms-zhaoyun-cradle-escape': {
    title: 'Відео — Three Kingdoms ARPG — Втеча Чжао Юня з немовлям (Seedance 2.0)',
    summary:
      'Кінематографічна екшн-послідовність тривалістю ~12 с, відтворена в рушії, яка оживляє супутній шаблон зображення game-screenshot-three-kingdoms-zhaoyun-cradle-escape. Чжао Юнь (赵云) мчить на своєму бойовому коні через зруйноване поле битви при Чанбані, тримаючи немовля-спадкоємця А Доу в згині лівої руки й орудуючи списом у правій, парирує ворожий удар одним ІДЕАЛЬНИМ УХИЛЕННЯМ і перестрибує через повалену бойову колісницю, щоб прокласти шлях. Налаштовано під Seedance 2.0 — суворий контроль камери, один безперервний момент, переконлива робота списом однією рукою, чиста фізика коня й абсолютно жодної видимої шкоди немовляті. Розроблено як прямий відеосупутник до відповідного шаблону зображення, щоб стоп-кадр і кліп можна було подавати в парі. Референсне зображення: шаблон скриншоту з втечею Чжао Юня з немовлям.',
  },
  'vintage-disney-style-pirate-crocodile-animation': {
    title: 'Анімація крокодила-пірата у вінтажному стилі Disney',
    summary:
      'Багатосценовий наративний промпт для класичної анімації у вінтажному стилі Disney за участю крокодила-пірата та птахів-піратів на кораблі.',
  },
  'viral-k-pop-dance-choreography': {
    title: 'Вірусна танцювальна хореографія K-pop',
    summary:
      'Детальний промпт для Seedance 2.0 для анімування персонажа, який виконує танець на основі референсного розкадрування з 16 панелей.',
  },
  'wasteland-factory-chase': {
    title: 'Погоня на фабриці в пустці',
    summary:
      'Кінематографічний промпт для високошвидкісної сцени в пустельній пустці за участю рухомої промислової фабрики на ногах і погоні бунтівника на мотоциклі.',
  },
};
